/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * product
 * product-api
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


import * as Url from 'url'

const url = Url as any
url.URLSearchParams = URLSearchParams

/**
 *
 *@export
 *@interface FetchArgs
 */
export interface FetchArgs {
  url: string;
  options: any;
  abort: () => void
}

/**
 *
 *@export
 *@class RequiredError
 *@extends {Error}
 */
export class RequiredError extends Error {
  name = "RequiredError"

  constructor(public field: string, msg?: string) {
    super(msg);
  }
}

/**
 * 
 * @export
 * @interface ApproveReviewRequest
 */
export interface ApproveReviewRequest {
    /**
     * 
     * @type {string}
     * @memberof ApproveReviewRequest
     */
    approved_status: ApproveReviewRequest.ApprovedStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ApproveReviewRequest
     */
    review_display?: ApproveReviewRequest.ReviewDisplayEnum;
    /**
     * 
     * @type {string}
     * @memberof ApproveReviewRequest
     */
    review_id: string;
}

/**
 * @export
 * @namespace ApproveReviewRequest
 */
export namespace ApproveReviewRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum ApprovedStatusEnum {
        PENDING = <any> 'PENDING',
        APPROVED = <any> 'APPROVED',
        REJECTED = <any> 'REJECTED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ReviewDisplayEnum {
        HIDDEN = <any> 'HIDDEN',
        VISIBLE = <any> 'VISIBLE'
    }
}

/**
 * 
 * @export
 * @interface AttributeResponse
 */
export interface AttributeResponse {
    /**
     * 
     * @type {string}
     * @memberof AttributeResponse
     */
    attribute_id?: string;
    /**
     * 
     * @type {string}
     * @memberof AttributeResponse
     */
    attribute_name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AttributeResponse
     */
    attribute_value_list?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AttributeResponse
     */
    catalog_id?: string;
    /**
     * 
     * @type {string}
     * @memberof AttributeResponse
     */
    remark?: string;
}

/**
 * 
 * @export
 * @interface CategoryAttributeDetailResponse
 */
export interface CategoryAttributeDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof CategoryAttributeDetailResponse
     */
    attribute_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryAttributeDetailResponse
     */
    attribute_name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CategoryAttributeDetailResponse
     */
    attribute_value_list?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CategoryAttributeDetailResponse
     */
    catalog_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryAttributeDetailResponse
     */
    category_attribute_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryAttributeDetailResponse
     */
    remark?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CategoryAttributeDetailResponse
     */
    required?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CategoryAttributeDetailResponse
     */
    show_in_channel?: boolean;
}

/**
 * 
 * @export
 * @interface CategoryAttributeRequest
 */
export interface CategoryAttributeRequest {
    /**
     * 
     * @type {Array<CreateCategoryAttributeRequest>}
     * @memberof CategoryAttributeRequest
     */
    attribute_list: Array<CreateCategoryAttributeRequest>;
}

/**
 * 
 * @export
 * @interface CategoryAttributeResponse
 */
export interface CategoryAttributeResponse {
    /**
     * 
     * @type {string}
     * @memberof CategoryAttributeResponse
     */
    attribute_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryAttributeResponse
     */
    catalog_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryAttributeResponse
     */
    category_attribute_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryAttributeResponse
     */
    category_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CategoryAttributeResponse
     */
    show_in_channel?: boolean;
}

/**
 * 
 * @export
 * @interface CategoryResponse
 */
export interface CategoryResponse {
    /**
     * 
     * @type {string}
     * @memberof CategoryResponse
     */
    catalog_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryResponse
     */
    category_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryResponse
     */
    category_image?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CategoryResponse
     */
    category_image_list?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CategoryResponse
     */
    category_name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CategoryResponse
     */
    category_tree_path?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CategoryResponse
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryResponse
     */
    external_category_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CategoryResponse
     */
    is_enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CategoryResponse
     */
    parent_category_id?: string;
    /**
     * 
     * @type {number}
     * @memberof CategoryResponse
     */
    sort?: number;
    /**
     * 
     * @type {number}
     * @memberof CategoryResponse
     */
    total_spu?: number;
    /**
     * 
     * @type {string}
     * @memberof CategoryResponse
     */
    updated_at?: string;
}

/**
 * 
 * @export
 * @interface CategoryTreeNodeResponse
 */
export interface CategoryTreeNodeResponse {
    /**
     * 
     * @type {string}
     * @memberof CategoryTreeNodeResponse
     */
    catalog_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryTreeNodeResponse
     */
    category_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryTreeNodeResponse
     */
    category_image?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CategoryTreeNodeResponse
     */
    category_image_list?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CategoryTreeNodeResponse
     */
    category_name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CategoryTreeNodeResponse
     */
    category_tree_path?: Array<string>;
    /**
     * 
     * @type {Array<CategoryTreeNodeResponse>}
     * @memberof CategoryTreeNodeResponse
     */
    child_categories?: Array<CategoryTreeNodeResponse>;
    /**
     * 
     * @type {string}
     * @memberof CategoryTreeNodeResponse
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryTreeNodeResponse
     */
    external_category_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CategoryTreeNodeResponse
     */
    is_enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CategoryTreeNodeResponse
     */
    parent_category_id?: string;
    /**
     * 
     * @type {number}
     * @memberof CategoryTreeNodeResponse
     */
    sort?: number;
    /**
     * 
     * @type {number}
     * @memberof CategoryTreeNodeResponse
     */
    total_spu?: number;
    /**
     * 
     * @type {string}
     * @memberof CategoryTreeNodeResponse
     */
    updated_at?: string;
}

/**
 * 
 * @export
 * @interface CategoryVariationAttributeDetailResponse
 */
export interface CategoryVariationAttributeDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof CategoryVariationAttributeDetailResponse
     */
    catalog_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryVariationAttributeDetailResponse
     */
    category_variation_attribute_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryVariationAttributeDetailResponse
     */
    remark?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CategoryVariationAttributeDetailResponse
     */
    required?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CategoryVariationAttributeDetailResponse
     */
    show_in_channel?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CategoryVariationAttributeDetailResponse
     */
    variation_attribute_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryVariationAttributeDetailResponse
     */
    variation_attribute_name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CategoryVariationAttributeDetailResponse
     */
    variation_attribute_value_list?: Array<string>;
}

/**
 * 
 * @export
 * @interface CategoryVariationAttributeRequest
 */
export interface CategoryVariationAttributeRequest {
    /**
     * 
     * @type {Array<CreateCategoryVariationAttributeRequest>}
     * @memberof CategoryVariationAttributeRequest
     */
    variation_attribute_list: Array<CreateCategoryVariationAttributeRequest>;
}

/**
 * 
 * @export
 * @interface CategoryVariationAttributeResponse
 */
export interface CategoryVariationAttributeResponse {
    /**
     * 
     * @type {string}
     * @memberof CategoryVariationAttributeResponse
     */
    catalog_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryVariationAttributeResponse
     */
    category_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryVariationAttributeResponse
     */
    category_variation_attribute_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CategoryVariationAttributeResponse
     */
    show_in_channel?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CategoryVariationAttributeResponse
     */
    variation_attribute_id?: string;
}

/**
 * 
 * @export
 * @interface CreateAttributeRequest
 */
export interface CreateAttributeRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateAttributeRequest
     */
    attribute_name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAttributeRequest
     */
    attribute_value_list: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateAttributeRequest
     */
    remark?: string;
}

/**
 * 
 * @export
 * @interface CreateCategoryAttributeRequest
 */
export interface CreateCategoryAttributeRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCategoryAttributeRequest
     */
    attribute_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCategoryAttributeRequest
     */
    show_in_channel?: boolean;
}

/**
 * 
 * @export
 * @interface CreateCategoryRequest
 */
export interface CreateCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCategoryRequest
     */
    category_image?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCategoryRequest
     */
    category_image_list?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateCategoryRequest
     */
    category_name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCategoryRequest
     */
    external_category_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCategoryRequest
     */
    is_enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateCategoryRequest
     */
    parent_category_id?: string;
}

/**
 * 
 * @export
 * @interface CreateCategoryVariationAttributeRequest
 */
export interface CreateCategoryVariationAttributeRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CreateCategoryVariationAttributeRequest
     */
    show_in_channel?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateCategoryVariationAttributeRequest
     */
    variation_attribute_id?: string;
}

/**
 * 
 * @export
 * @interface CreateGiftSpuRequest
 */
export interface CreateGiftSpuRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateGiftSpuRequest
     */
    external_spu_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGiftSpuRequest
     */
    spu_code?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGiftSpuRequest
     */
    spu_description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateGiftSpuRequest
     */
    spu_detail_html?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateGiftSpuRequest
     */
    spu_image_list?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateGiftSpuRequest
     */
    spu_main_image?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGiftSpuRequest
     */
    spu_name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGiftSpuRequest
     */
    spu_rich_text?: string;
}

/**
 * 
 * @export
 * @interface CreateGiftSpuResponse
 */
export interface CreateGiftSpuResponse {
    /**
     * 
     * @type {Array<SpuAttributeBusiness>}
     * @memberof CreateGiftSpuResponse
     */
    attribute_list?: Array<SpuAttributeBusiness>;
    /**
     * 
     * @type {string}
     * @memberof CreateGiftSpuResponse
     */
    catalog_id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateGiftSpuResponse
     */
    category_id_list?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateGiftSpuResponse
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGiftSpuResponse
     */
    external_spu_id?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateGiftSpuResponse
     */
    max_sell_price?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateGiftSpuResponse
     */
    min_sell_price?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateGiftSpuResponse
     */
    offline_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGiftSpuResponse
     */
    online_at?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateGiftSpuResponse
     */
    searchable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateGiftSpuResponse
     */
    sku_type?: CreateGiftSpuResponse.SkuTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateGiftSpuResponse
     */
    spu_code?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGiftSpuResponse
     */
    spu_description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateGiftSpuResponse
     */
    spu_detail_html?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateGiftSpuResponse
     */
    spu_id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateGiftSpuResponse
     */
    spu_image_list?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateGiftSpuResponse
     */
    spu_main_image?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGiftSpuResponse
     */
    spu_name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGiftSpuResponse
     */
    spu_rich_text?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGiftSpuResponse
     */
    spu_status?: CreateGiftSpuResponse.SpuStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateGiftSpuResponse
     */
    spu_status_modified_at?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateGiftSpuResponse
     */
    total_sku?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateGiftSpuResponse
     */
    updated_at?: string;
    /**
     * 
     * @type {Array<SpuVariationAttributeBusiness>}
     * @memberof CreateGiftSpuResponse
     */
    variation_attribute_list?: Array<SpuVariationAttributeBusiness>;
}

/**
 * @export
 * @namespace CreateGiftSpuResponse
 */
export namespace CreateGiftSpuResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum SkuTypeEnum {
        NONE = <any> 'NONE',
        SINGLE = <any> 'SINGLE',
        MULTIPLE = <any> 'MULTIPLE'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SpuStatusEnum {
        ENABLED = <any> 'ENABLED',
        DISABLED = <any> 'DISABLED'
    }
}

/**
 * 
 * @export
 * @interface CreateSpuRequest
 */
export interface CreateSpuRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSpuRequest
     */
    category_id_list?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuRequest
     */
    external_spu_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSpuRequest
     */
    is_bottom?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuRequest
     */
    main_video_media_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSpuRequest
     */
    presale?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuRequest
     */
    presale_end_action?: CreateSpuRequest.PresaleEndActionEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuRequest
     */
    presale_end_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuRequest
     */
    presale_start_at?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSpuRequest
     */
    searchable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuRequest
     */
    spu_code?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuRequest
     */
    spu_description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSpuRequest
     */
    spu_detail_html?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSpuRequest
     */
    spu_image_list?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuRequest
     */
    spu_main_image?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuRequest
     */
    spu_name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuRequest
     */
    spu_rich_text?: string;
}

/**
 * @export
 * @namespace CreateSpuRequest
 */
export namespace CreateSpuRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum PresaleEndActionEnum {
        UNKNOWN = <any> 'UNKNOWN',
        TRANSFERTONORMAL = <any> 'TRANSFER_TO_NORMAL',
        DISABLED = <any> 'DISABLED'
    }
}

/**
 * 
 * @export
 * @interface CreateSpuResponse
 */
export interface CreateSpuResponse {
    /**
     * 
     * @type {Array<SpuAttributeBusiness>}
     * @memberof CreateSpuResponse
     */
    attribute_list?: Array<SpuAttributeBusiness>;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuResponse
     */
    catalog_id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSpuResponse
     */
    category_id_list?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuResponse
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuResponse
     */
    external_spu_id?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateSpuResponse
     */
    max_sell_price?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSpuResponse
     */
    min_sell_price?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuResponse
     */
    offline_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuResponse
     */
    online_at?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSpuResponse
     */
    presale?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuResponse
     */
    presale_end_action?: CreateSpuResponse.PresaleEndActionEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateSpuResponse
     */
    presale_end_at?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSpuResponse
     */
    presale_start_at?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSpuResponse
     */
    searchable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuResponse
     */
    sku_type?: CreateSpuResponse.SkuTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuResponse
     */
    spu_code?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuResponse
     */
    spu_description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSpuResponse
     */
    spu_detail_html?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuResponse
     */
    spu_id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSpuResponse
     */
    spu_image_list?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuResponse
     */
    spu_main_image?: string;
    /**
     * 
     * @type {SpuMainVideo}
     * @memberof CreateSpuResponse
     */
    spu_main_video?: SpuMainVideo;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuResponse
     */
    spu_name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuResponse
     */
    spu_rich_text?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuResponse
     */
    spu_status?: CreateSpuResponse.SpuStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuResponse
     */
    spu_status_modified_at?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateSpuResponse
     */
    total_sku?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateSpuResponse
     */
    updated_at?: string;
    /**
     * 
     * @type {Array<SpuVariationAttributeBusiness>}
     * @memberof CreateSpuResponse
     */
    variation_attribute_list?: Array<SpuVariationAttributeBusiness>;
}

/**
 * @export
 * @namespace CreateSpuResponse
 */
export namespace CreateSpuResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum PresaleEndActionEnum {
        UNKNOWN = <any> 'UNKNOWN',
        TRANSFERTONORMAL = <any> 'TRANSFER_TO_NORMAL',
        DISABLED = <any> 'DISABLED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SkuTypeEnum {
        NONE = <any> 'NONE',
        SINGLE = <any> 'SINGLE',
        MULTIPLE = <any> 'MULTIPLE'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SpuStatusEnum {
        ENABLED = <any> 'ENABLED',
        DISABLED = <any> 'DISABLED'
    }
}

/**
 * 
 * @export
 * @interface CreateVariationAttributeRequest
 */
export interface CreateVariationAttributeRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateVariationAttributeRequest
     */
    remark?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVariationAttributeRequest
     */
    variation_attribute_name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateVariationAttributeRequest
     */
    variation_attribute_value_list: Array<string>;
}

/**
 * 
 * @export
 * @interface DisplayReviewRequest
 */
export interface DisplayReviewRequest {
    /**
     * 
     * @type {string}
     * @memberof DisplayReviewRequest
     */
    review_display: DisplayReviewRequest.ReviewDisplayEnum;
    /**
     * 
     * @type {string}
     * @memberof DisplayReviewRequest
     */
    review_id: string;
}

/**
 * @export
 * @namespace DisplayReviewRequest
 */
export namespace DisplayReviewRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum ReviewDisplayEnum {
        HIDDEN = <any> 'HIDDEN',
        VISIBLE = <any> 'VISIBLE'
    }
}

/**
 * 
 * @export
 * @interface ExternalSkuInventoryRequest
 */
export interface ExternalSkuInventoryRequest {
    /**
     * will filter with external_spu_id if given
     * @type {string}
     * @memberof ExternalSkuInventoryRequest
     */
    external_spu_id?: string;
    /**
     * 
     * @type {number}
     * @memberof ExternalSkuInventoryRequest
     */
    inventory: number;
    /**
     * will filter with spu_id if given
     * @type {string}
     * @memberof ExternalSkuInventoryRequest
     */
    spu_id?: string;
}

/**
 * 
 * @export
 * @interface GiftSpuResponse
 */
export interface GiftSpuResponse {
    /**
     * 
     * @type {Array<SpuAttributeBusiness>}
     * @memberof GiftSpuResponse
     */
    attribute_list?: Array<SpuAttributeBusiness>;
    /**
     * 
     * @type {string}
     * @memberof GiftSpuResponse
     */
    catalog_id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GiftSpuResponse
     */
    category_id_list?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GiftSpuResponse
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof GiftSpuResponse
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof GiftSpuResponse
     */
    external_spu_id?: string;
    /**
     * 
     * @type {number}
     * @memberof GiftSpuResponse
     */
    max_sell_price?: number;
    /**
     * 
     * @type {number}
     * @memberof GiftSpuResponse
     */
    min_sell_price?: number;
    /**
     * 
     * @type {string}
     * @memberof GiftSpuResponse
     */
    offline_at?: string;
    /**
     * 
     * @type {string}
     * @memberof GiftSpuResponse
     */
    online_at?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GiftSpuResponse
     */
    searchable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GiftSpuResponse
     */
    sku_type?: GiftSpuResponse.SkuTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GiftSpuResponse
     */
    spu_code?: string;
    /**
     * 
     * @type {string}
     * @memberof GiftSpuResponse
     */
    spu_description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GiftSpuResponse
     */
    spu_detail_html?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GiftSpuResponse
     */
    spu_id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GiftSpuResponse
     */
    spu_image_list?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GiftSpuResponse
     */
    spu_main_image?: string;
    /**
     * 
     * @type {string}
     * @memberof GiftSpuResponse
     */
    spu_name?: string;
    /**
     * 
     * @type {string}
     * @memberof GiftSpuResponse
     */
    spu_rich_text?: string;
    /**
     * 
     * @type {string}
     * @memberof GiftSpuResponse
     */
    spu_status?: GiftSpuResponse.SpuStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GiftSpuResponse
     */
    spu_status_modified_at?: string;
    /**
     * 
     * @type {string}
     * @memberof GiftSpuResponse
     */
    updated_at?: string;
    /**
     * 
     * @type {Array<SpuVariationAttributeBusiness>}
     * @memberof GiftSpuResponse
     */
    variation_attribute_list?: Array<SpuVariationAttributeBusiness>;
}

/**
 * @export
 * @namespace GiftSpuResponse
 */
export namespace GiftSpuResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum SkuTypeEnum {
        NONE = <any> 'NONE',
        SINGLE = <any> 'SINGLE',
        MULTIPLE = <any> 'MULTIPLE'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SpuStatusEnum {
        ENABLED = <any> 'ENABLED',
        DISABLED = <any> 'DISABLED'
    }
}

/**
 * 
 * @export
 * @interface KeyValue
 */
export interface KeyValue {
    /**
     * 
     * @type {string}
     * @memberof KeyValue
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof KeyValue
     */
    value?: string;
}

/**
 * 
 * @export
 * @interface KeyValueWithId
 */
export interface KeyValueWithId {
    /**
     * 
     * @type {string}
     * @memberof KeyValueWithId
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof KeyValueWithId
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof KeyValueWithId
     */
    variation_attribute_id?: string;
}

/**
 * 
 * @export
 * @interface OptionalUpdateCategoryRequest
 */
export interface OptionalUpdateCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof OptionalUpdateCategoryRequest
     */
    category_image?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OptionalUpdateCategoryRequest
     */
    category_image_list?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OptionalUpdateCategoryRequest
     */
    category_name?: string;
    /**
     * 
     * @type {string}
     * @memberof OptionalUpdateCategoryRequest
     */
    external_category_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OptionalUpdateCategoryRequest
     */
    is_enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OptionalUpdateCategoryRequest
     */
    parent_category_id?: string;
}

/**
 * 
 * @export
 * @interface OptionalUpdateSpuRequest
 */
export interface OptionalUpdateSpuRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof OptionalUpdateSpuRequest
     */
    category_id_list?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OptionalUpdateSpuRequest
     */
    external_spu_id?: string;
    /**
     * 
     * @type {string}
     * @memberof OptionalUpdateSpuRequest
     */
    main_video_media_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OptionalUpdateSpuRequest
     */
    searchable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OptionalUpdateSpuRequest
     */
    spu_code?: string;
    /**
     * 
     * @type {string}
     * @memberof OptionalUpdateSpuRequest
     */
    spu_description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OptionalUpdateSpuRequest
     */
    spu_detail_html?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OptionalUpdateSpuRequest
     */
    spu_image_list?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OptionalUpdateSpuRequest
     */
    spu_main_image?: string;
    /**
     * 
     * @type {string}
     * @memberof OptionalUpdateSpuRequest
     */
    spu_name?: string;
    /**
     * 
     * @type {string}
     * @memberof OptionalUpdateSpuRequest
     */
    spu_rich_text?: string;
}

/**
 * 
 * @export
 * @interface PageQueryResponseReviewResponse
 */
export interface PageQueryResponseReviewResponse {
    /**
     * 
     * @type {number}
     * @memberof PageQueryResponseReviewResponse
     */
    current_page?: number;
    /**
     * 
     * @type {Array<ReviewResponse>}
     * @memberof PageQueryResponseReviewResponse
     */
    list?: Array<ReviewResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageQueryResponseReviewResponse
     */
    num?: number;
    /**
     * 
     * @type {number}
     * @memberof PageQueryResponseReviewResponse
     */
    total_num?: number;
    /**
     * 
     * @type {number}
     * @memberof PageQueryResponseReviewResponse
     */
    total_page?: number;
}

/**
 * 
 * @export
 * @interface PageQueryResponseSimpleSpuResponse
 */
export interface PageQueryResponseSimpleSpuResponse {
    /**
     * 
     * @type {number}
     * @memberof PageQueryResponseSimpleSpuResponse
     */
    current_page?: number;
    /**
     * 
     * @type {Array<SimpleSpuResponse>}
     * @memberof PageQueryResponseSimpleSpuResponse
     */
    list?: Array<SimpleSpuResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageQueryResponseSimpleSpuResponse
     */
    num?: number;
    /**
     * 
     * @type {number}
     * @memberof PageQueryResponseSimpleSpuResponse
     */
    total_num?: number;
    /**
     * 
     * @type {number}
     * @memberof PageQueryResponseSimpleSpuResponse
     */
    total_page?: number;
}

/**
 * 
 * @export
 * @interface PatchUpdateFilterRequest
 */
export interface PatchUpdateFilterRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PatchUpdateFilterRequest
     */
    show_in_channel?: boolean;
}

/**
 * 
 * @export
 * @interface ReviewDetailResponse
 */
export interface ReviewDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof ReviewDetailResponse
     */
    approved_by?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewDetailResponse
     */
    approved_by_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewDetailResponse
     */
    approved_remark?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewDetailResponse
     */
    approved_status?: ReviewDetailResponse.ApprovedStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ReviewDetailResponse
     */
    channel?: number;
    /**
     * 
     * @type {string}
     * @memberof ReviewDetailResponse
     */
    channel_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewDetailResponse
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewDetailResponse
     */
    created_at?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReviewDetailResponse
     */
    images?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ReviewDetailResponse
     */
    order_no?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewDetailResponse
     */
    review_display?: ReviewDetailResponse.ReviewDisplayEnum;
    /**
     * 
     * @type {string}
     * @memberof ReviewDetailResponse
     */
    review_id?: string;
    /**
     * 
     * @type {number}
     * @memberof ReviewDetailResponse
     */
    score?: number;
    /**
     * 
     * @type {ReviewSku}
     * @memberof ReviewDetailResponse
     */
    sku?: ReviewSku;
    /**
     * 
     * @type {string}
     * @memberof ReviewDetailResponse
     */
    spu_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewDetailResponse
     */
    storefront_customer_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewDetailResponse
     */
    storefront_customer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewDetailResponse
     */
    storefront_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewDetailResponse
     */
    storefront_name?: string;
}

/**
 * @export
 * @namespace ReviewDetailResponse
 */
export namespace ReviewDetailResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum ApprovedStatusEnum {
        PENDING = <any> 'PENDING',
        APPROVED = <any> 'APPROVED',
        REJECTED = <any> 'REJECTED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ReviewDisplayEnum {
        HIDDEN = <any> 'HIDDEN',
        VISIBLE = <any> 'VISIBLE'
    }
}

/**
 * 
 * @export
 * @interface ReviewResponse
 */
export interface ReviewResponse {
    /**
     * 
     * @type {string}
     * @memberof ReviewResponse
     */
    approved_remark?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewResponse
     */
    approved_status?: ReviewResponse.ApprovedStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ReviewResponse
     */
    channel_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewResponse
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewResponse
     */
    created_at?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReviewResponse
     */
    images?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ReviewResponse
     */
    review_display?: ReviewResponse.ReviewDisplayEnum;
    /**
     * 
     * @type {string}
     * @memberof ReviewResponse
     */
    review_id?: string;
    /**
     * 
     * @type {number}
     * @memberof ReviewResponse
     */
    score?: number;
    /**
     * 
     * @type {ReviewSku}
     * @memberof ReviewResponse
     */
    sku?: ReviewSku;
    /**
     * 
     * @type {string}
     * @memberof ReviewResponse
     */
    spu_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewResponse
     */
    storefront_name?: string;
}

/**
 * @export
 * @namespace ReviewResponse
 */
export namespace ReviewResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum ApprovedStatusEnum {
        PENDING = <any> 'PENDING',
        APPROVED = <any> 'APPROVED',
        REJECTED = <any> 'REJECTED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ReviewDisplayEnum {
        HIDDEN = <any> 'HIDDEN',
        VISIBLE = <any> 'VISIBLE'
    }
}

/**
 * 
 * @export
 * @interface ReviewSku
 */
export interface ReviewSku {
    /**
     * 
     * @type {string}
     * @memberof ReviewSku
     */
    image?: string;
    /**
     * 
     * @type {number}
     * @memberof ReviewSku
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof ReviewSku
     */
    sell_price?: number;
    /**
     * 
     * @type {string}
     * @memberof ReviewSku
     */
    sku_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewSku
     */
    spu_name?: string;
    /**
     * 
     * @type {Array<KeyValue>}
     * @memberof ReviewSku
     */
    variation_attribute?: Array<KeyValue>;
}

/**
 * 
 * @export
 * @interface SimpleSpuResponse
 */
export interface SimpleSpuResponse {
    /**
     * 
     * @type {Array<SpuAttributeBusiness>}
     * @memberof SimpleSpuResponse
     */
    attribute_list?: Array<SpuAttributeBusiness>;
    /**
     * 
     * @type {string}
     * @memberof SimpleSpuResponse
     */
    catalog_id?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleSpuResponse
     */
    external_spu_id?: string;
    /**
     * 
     * @type {number}
     * @memberof SimpleSpuResponse
     */
    inventory?: number;
    /**
     * 
     * @type {number}
     * @memberof SimpleSpuResponse
     */
    max_sell_price?: number;
    /**
     * 
     * @type {number}
     * @memberof SimpleSpuResponse
     */
    min_sell_price?: number;
    /**
     * 
     * @type {string}
     * @memberof SimpleSpuResponse
     */
    offline_at?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleSpuResponse
     */
    online_at?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SimpleSpuResponse
     */
    presale?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SimpleSpuResponse
     */
    presale_end_action?: SimpleSpuResponse.PresaleEndActionEnum;
    /**
     * 
     * @type {number}
     * @memberof SimpleSpuResponse
     */
    presale_end_at?: number;
    /**
     * 
     * @type {number}
     * @memberof SimpleSpuResponse
     */
    presale_start_at?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SimpleSpuResponse
     */
    searchable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SimpleSpuResponse
     */
    sku_type?: SimpleSpuResponse.SkuTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SimpleSpuResponse
     */
    sort?: number;
    /**
     * 
     * @type {string}
     * @memberof SimpleSpuResponse
     */
    spu_code?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleSpuResponse
     */
    spu_description?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleSpuResponse
     */
    spu_id?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleSpuResponse
     */
    spu_main_image?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleSpuResponse
     */
    spu_main_video_state?: SimpleSpuResponse.SpuMainVideoStateEnum;
    /**
     * 
     * @type {string}
     * @memberof SimpleSpuResponse
     */
    spu_name?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleSpuResponse
     */
    spu_status?: SimpleSpuResponse.SpuStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SimpleSpuResponse
     */
    spu_status_modified_at?: string;
    /**
     * 
     * @type {Array<SpuVariationAttributeBusiness>}
     * @memberof SimpleSpuResponse
     */
    variation_attribute_list?: Array<SpuVariationAttributeBusiness>;
}

/**
 * @export
 * @namespace SimpleSpuResponse
 */
export namespace SimpleSpuResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum PresaleEndActionEnum {
        UNKNOWN = <any> 'UNKNOWN',
        TRANSFERTONORMAL = <any> 'TRANSFER_TO_NORMAL',
        DISABLED = <any> 'DISABLED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SkuTypeEnum {
        NONE = <any> 'NONE',
        SINGLE = <any> 'SINGLE',
        MULTIPLE = <any> 'MULTIPLE'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SpuMainVideoStateEnum {
        NONE = <any> 'NONE',
        TRANSCODING = <any> 'TRANSCODING',
        AVAILABLE = <any> 'AVAILABLE',
        ERROR = <any> 'ERROR',
        APPROVING = <any> 'APPROVING',
        REJECTED = <any> 'REJECTED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SpuStatusEnum {
        ENABLED = <any> 'ENABLED',
        DISABLED = <any> 'DISABLED'
    }
}

/**
 * 
 * @export
 * @interface SkuInventoryRequest
 */
export interface SkuInventoryRequest {
    /**
     * 
     * @type {number}
     * @memberof SkuInventoryRequest
     */
    inventory: number;
}

/**
 * 
 * @export
 * @interface SkuInventoryResponse
 */
export interface SkuInventoryResponse {
    /**
     * 
     * @type {string}
     * @memberof SkuInventoryResponse
     */
    external_sku_id?: string;
    /**
     * 
     * @type {string}
     * @memberof SkuInventoryResponse
     */
    external_spu_id?: string;
    /**
     * 
     * @type {number}
     * @memberof SkuInventoryResponse
     */
    inventory?: number;
    /**
     * 
     * @type {string}
     * @memberof SkuInventoryResponse
     */
    sku_code?: string;
    /**
     * 
     * @type {string}
     * @memberof SkuInventoryResponse
     */
    sku_id?: string;
    /**
     * 
     * @type {string}
     * @memberof SkuInventoryResponse
     */
    spu_id?: string;
}

/**
 * 
 * @export
 * @interface SkuListRequest
 */
export interface SkuListRequest {
    /**
     * 
     * @type {Array<UpdateSkuRequest>}
     * @memberof SkuListRequest
     */
    sku_list: Array<UpdateSkuRequest>;
}

/**
 * 
 * @export
 * @interface SkuPurchaseLimit
 */
export interface SkuPurchaseLimit {
    /**
     * 
     * @type {number}
     * @memberof SkuPurchaseLimit
     */
    purchase_limit?: number;
    /**
     * 
     * @type {string}
     * @memberof SkuPurchaseLimit
     */
    purchase_limit_status?: SkuPurchaseLimit.PurchaseLimitStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SkuPurchaseLimit
     */
    sku_code?: string;
    /**
     * 
     * @type {string}
     * @memberof SkuPurchaseLimit
     */
    sku_id?: string;
    /**
     * 
     * @type {string}
     * @memberof SkuPurchaseLimit
     */
    sku_image?: string;
    /**
     * 
     * @type {Array<KeyValueWithId>}
     * @memberof SkuPurchaseLimit
     */
    variation_attributes_list?: Array<KeyValueWithId>;
}

/**
 * @export
 * @namespace SkuPurchaseLimit
 */
export namespace SkuPurchaseLimit {
    /**
     * @export
     * @enum {string}
     */
    export enum PurchaseLimitStatusEnum {
        DISABLED = <any> 'DISABLED',
        ENABLED = <any> 'ENABLED'
    }
}

/**
 * 
 * @export
 * @interface SkuPurchaseLimit1
 */
export interface SkuPurchaseLimit1 {
    /**
     * 
     * @type {number}
     * @memberof SkuPurchaseLimit1
     */
    purchase_limit?: number;
    /**
     * 
     * @type {string}
     * @memberof SkuPurchaseLimit1
     */
    purchase_limit_status?: SkuPurchaseLimit1.PurchaseLimitStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SkuPurchaseLimit1
     */
    sku_id: string;
}

/**
 * @export
 * @namespace SkuPurchaseLimit1
 */
export namespace SkuPurchaseLimit1 {
    /**
     * @export
     * @enum {string}
     */
    export enum PurchaseLimitStatusEnum {
        DISABLED = <any> 'DISABLED',
        ENABLED = <any> 'ENABLED'
    }
}

/**
 * 
 * @export
 * @interface SkuRequest
 */
export interface SkuRequest {
    /**
     * 
     * @type {number}
     * @memberof SkuRequest
     */
    cost_price?: number;
    /**
     * 
     * @type {string}
     * @memberof SkuRequest
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof SkuRequest
     */
    external_sku_id?: string;
    /**
     * 
     * @type {number}
     * @memberof SkuRequest
     */
    inventory: number;
    /**
     * 
     * @type {boolean}
     * @memberof SkuRequest
     */
    is_enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof SkuRequest
     */
    market_price?: number;
    /**
     * 
     * @type {number}
     * @memberof SkuRequest
     */
    sell_price: number;
    /**
     * 
     * @type {string}
     * @memberof SkuRequest
     */
    sku_code?: string;
    /**
     * 
     * @type {string}
     * @memberof SkuRequest
     */
    sku_id?: string;
    /**
     * 
     * @type {string}
     * @memberof SkuRequest
     */
    sku_image?: string;
    /**
     * 
     * @type {Array<KeyValueWithId>}
     * @memberof SkuRequest
     */
    variation_attributes_list?: Array<KeyValueWithId>;
    /**
     * 
     * @type {number}
     * @memberof SkuRequest
     */
    volume?: number;
    /**
     * 
     * @type {string}
     * @memberof SkuRequest
     */
    volume_unit?: string;
    /**
     * 
     * @type {number}
     * @memberof SkuRequest
     */
    weight?: number;
    /**
     * 
     * @type {string}
     * @memberof SkuRequest
     */
    weight_unit?: string;
}

/**
 * 
 * @export
 * @interface SkuResponse
 */
export interface SkuResponse {
    /**
     * 
     * @type {string}
     * @memberof SkuResponse
     */
    catalog_id?: string;
    /**
     * 
     * @type {number}
     * @memberof SkuResponse
     */
    cost_price?: number;
    /**
     * 
     * @type {string}
     * @memberof SkuResponse
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof SkuResponse
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof SkuResponse
     */
    external_sku_id?: string;
    /**
     * 
     * @type {number}
     * @memberof SkuResponse
     */
    inventory?: number;
    /**
     * 
     * @type {string}
     * @memberof SkuResponse
     */
    inventory_state?: SkuResponse.InventoryStateEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SkuResponse
     */
    is_enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SkuResponse
     */
    market_price?: number;
    /**
     * 
     * @type {number}
     * @memberof SkuResponse
     */
    sell_price?: number;
    /**
     * 
     * @type {string}
     * @memberof SkuResponse
     */
    sku_code?: string;
    /**
     * 
     * @type {string}
     * @memberof SkuResponse
     */
    sku_id?: string;
    /**
     * 
     * @type {string}
     * @memberof SkuResponse
     */
    sku_image?: string;
    /**
     * 
     * @type {string}
     * @memberof SkuResponse
     */
    updated_at?: string;
    /**
     * 
     * @type {Array<KeyValueWithId>}
     * @memberof SkuResponse
     */
    variation_attributes_list?: Array<KeyValueWithId>;
    /**
     * 
     * @type {number}
     * @memberof SkuResponse
     */
    volume?: number;
    /**
     * 
     * @type {string}
     * @memberof SkuResponse
     */
    volume_unit?: string;
    /**
     * 
     * @type {number}
     * @memberof SkuResponse
     */
    weight?: number;
    /**
     * 
     * @type {string}
     * @memberof SkuResponse
     */
    weight_unit?: string;
}

/**
 * @export
 * @namespace SkuResponse
 */
export namespace SkuResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum InventoryStateEnum {
        VALID = <any> 'VALID',
        INVALID = <any> 'INVALID'
    }
}

/**
 * 
 * @export
 * @interface SkuStatusRequest
 */
export interface SkuStatusRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SkuStatusRequest
     */
    is_enabled: boolean;
}

/**
 * 
 * @export
 * @interface SpuAttributeBusiness
 */
export interface SpuAttributeBusiness {
    /**
     * 
     * @type {string}
     * @memberof SpuAttributeBusiness
     */
    attribute_id: string;
    /**
     * 
     * @type {string}
     * @memberof SpuAttributeBusiness
     */
    attribute_name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SpuAttributeBusiness
     */
    attribute_value_list: Array<string>;
}

/**
 * 
 * @export
 * @interface SpuMainVideo
 */
export interface SpuMainVideo {
    /**
     * 
     * @type {string}
     * @memberof SpuMainVideo
     */
    cover_url?: string;
    /**
     * 
     * @type {string}
     * @memberof SpuMainVideo
     */
    default_cover_url?: string;
    /**
     * 
     * @type {string}
     * @memberof SpuMainVideo
     */
    outer_video_url?: string;
    /**
     * 
     * @type {string}
     * @memberof SpuMainVideo
     */
    video_media_id?: string;
    /**
     * 
     * @type {string}
     * @memberof SpuMainVideo
     */
    video_state?: SpuMainVideo.VideoStateEnum;
    /**
     * 
     * @type {string}
     * @memberof SpuMainVideo
     */
    video_url?: string;
}

/**
 * @export
 * @namespace SpuMainVideo
 */
export namespace SpuMainVideo {
    /**
     * @export
     * @enum {string}
     */
    export enum VideoStateEnum {
        NONE = <any> 'NONE',
        TRANSCODING = <any> 'TRANSCODING',
        AVAILABLE = <any> 'AVAILABLE',
        ERROR = <any> 'ERROR',
        APPROVING = <any> 'APPROVING',
        REJECTED = <any> 'REJECTED'
    }
}

/**
 * 
 * @export
 * @interface SpuPurchaseLimitResponse
 */
export interface SpuPurchaseLimitResponse {
    /**
     * 
     * @type {string}
     * @memberof SpuPurchaseLimitResponse
     */
    external_spu_id?: string;
    /**
     * 
     * @type {number}
     * @memberof SpuPurchaseLimitResponse
     */
    purchase_limit?: number;
    /**
     * 
     * @type {string}
     * @memberof SpuPurchaseLimitResponse
     */
    purchase_limit_status?: SpuPurchaseLimitResponse.PurchaseLimitStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SpuPurchaseLimitResponse
     */
    purchase_limit_type?: SpuPurchaseLimitResponse.PurchaseLimitTypeEnum;
    /**
     * 
     * @type {Array<SkuPurchaseLimit>}
     * @memberof SpuPurchaseLimitResponse
     */
    sku_purchase_limit?: Array<SkuPurchaseLimit>;
    /**
     * 
     * @type {string}
     * @memberof SpuPurchaseLimitResponse
     */
    sku_type?: SpuPurchaseLimitResponse.SkuTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SpuPurchaseLimitResponse
     */
    spu_code?: string;
    /**
     * 
     * @type {string}
     * @memberof SpuPurchaseLimitResponse
     */
    spu_id?: string;
    /**
     * 
     * @type {Array<SpuVariationAttribute>}
     * @memberof SpuPurchaseLimitResponse
     */
    variation_attributes?: Array<SpuVariationAttribute>;
}

/**
 * @export
 * @namespace SpuPurchaseLimitResponse
 */
export namespace SpuPurchaseLimitResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum PurchaseLimitStatusEnum {
        DISABLED = <any> 'DISABLED',
        ENABLED = <any> 'ENABLED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PurchaseLimitTypeEnum {
        DISABLED = <any> 'DISABLED',
        SPU = <any> 'SPU',
        SKU = <any> 'SKU'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SkuTypeEnum {
        NONE = <any> 'NONE',
        SINGLE = <any> 'SINGLE',
        MULTIPLE = <any> 'MULTIPLE'
    }
}

/**
 * 
 * @export
 * @interface SpuResponse
 */
export interface SpuResponse {
    /**
     * 
     * @type {Array<SpuAttributeBusiness>}
     * @memberof SpuResponse
     */
    attribute_list?: Array<SpuAttributeBusiness>;
    /**
     * 
     * @type {string}
     * @memberof SpuResponse
     */
    catalog_id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SpuResponse
     */
    category_id_list?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SpuResponse
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof SpuResponse
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof SpuResponse
     */
    external_spu_id?: string;
    /**
     * 
     * @type {number}
     * @memberof SpuResponse
     */
    max_sell_price?: number;
    /**
     * 
     * @type {number}
     * @memberof SpuResponse
     */
    min_sell_price?: number;
    /**
     * 
     * @type {string}
     * @memberof SpuResponse
     */
    offline_at?: string;
    /**
     * 
     * @type {string}
     * @memberof SpuResponse
     */
    online_at?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SpuResponse
     */
    presale?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SpuResponse
     */
    presale_end_action?: SpuResponse.PresaleEndActionEnum;
    /**
     * 
     * @type {number}
     * @memberof SpuResponse
     */
    presale_end_at?: number;
    /**
     * 
     * @type {number}
     * @memberof SpuResponse
     */
    presale_start_at?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SpuResponse
     */
    searchable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SpuResponse
     */
    sku_type?: SpuResponse.SkuTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SpuResponse
     */
    spu_code?: string;
    /**
     * 
     * @type {string}
     * @memberof SpuResponse
     */
    spu_description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SpuResponse
     */
    spu_detail_html?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SpuResponse
     */
    spu_id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SpuResponse
     */
    spu_image_list?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SpuResponse
     */
    spu_main_image?: string;
    /**
     * 
     * @type {SpuMainVideo}
     * @memberof SpuResponse
     */
    spu_main_video?: SpuMainVideo;
    /**
     * 
     * @type {string}
     * @memberof SpuResponse
     */
    spu_name?: string;
    /**
     * 
     * @type {string}
     * @memberof SpuResponse
     */
    spu_rich_text?: string;
    /**
     * 
     * @type {string}
     * @memberof SpuResponse
     */
    spu_status?: SpuResponse.SpuStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SpuResponse
     */
    spu_status_modified_at?: string;
    /**
     * 
     * @type {string}
     * @memberof SpuResponse
     */
    updated_at?: string;
    /**
     * 
     * @type {Array<SpuVariationAttributeBusiness>}
     * @memberof SpuResponse
     */
    variation_attribute_list?: Array<SpuVariationAttributeBusiness>;
}

/**
 * @export
 * @namespace SpuResponse
 */
export namespace SpuResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum PresaleEndActionEnum {
        UNKNOWN = <any> 'UNKNOWN',
        TRANSFERTONORMAL = <any> 'TRANSFER_TO_NORMAL',
        DISABLED = <any> 'DISABLED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SkuTypeEnum {
        NONE = <any> 'NONE',
        SINGLE = <any> 'SINGLE',
        MULTIPLE = <any> 'MULTIPLE'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SpuStatusEnum {
        ENABLED = <any> 'ENABLED',
        DISABLED = <any> 'DISABLED'
    }
}

/**
 * 
 * @export
 * @interface SpuSort
 */
export interface SpuSort {
    /**
     * 
     * @type {number}
     * @memberof SpuSort
     */
    sort: number;
    /**
     * 
     * @type {string}
     * @memberof SpuSort
     */
    spu_id: string;
}

/**
 * 
 * @export
 * @interface SpuVariationAttribute
 */
export interface SpuVariationAttribute {
    /**
     * 
     * @type {string}
     * @memberof SpuVariationAttribute
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SpuVariationAttribute
     */
    values?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SpuVariationAttribute
     */
    variation_attribute_id?: string;
}

/**
 * 
 * @export
 * @interface SpuVariationAttributeBusiness
 */
export interface SpuVariationAttributeBusiness {
    /**
     * 
     * @type {string}
     * @memberof SpuVariationAttributeBusiness
     */
    variation_attribute_id: string;
    /**
     * 
     * @type {string}
     * @memberof SpuVariationAttributeBusiness
     */
    variation_attribute_name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SpuVariationAttributeBusiness
     */
    variation_attribute_value_list: Array<string>;
}

/**
 * 
 * @export
 * @interface UpdateAttributeRequest
 */
export interface UpdateAttributeRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateAttributeRequest
     */
    attribute_name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateAttributeRequest
     */
    attribute_value_list: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateAttributeRequest
     */
    remark?: string;
}

/**
 * 
 * @export
 * @interface UpdateCategoriesSortingRequest
 */
export interface UpdateCategoriesSortingRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateCategoriesSortingRequest
     */
    category_id_list?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateCategoriesSortingRequest
     */
    parent_id?: string;
}

/**
 * 
 * @export
 * @interface UpdateCategoryRequest
 */
export interface UpdateCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCategoryRequest
     */
    category_image?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateCategoryRequest
     */
    category_image_list?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateCategoryRequest
     */
    category_name: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCategoryRequest
     */
    is_enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateCategoryRequest
     */
    parent_category_id?: string;
}

/**
 * 
 * @export
 * @interface UpdateGiftSpuRequest
 */
export interface UpdateGiftSpuRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateGiftSpuRequest
     */
    spu_code?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGiftSpuRequest
     */
    spu_description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateGiftSpuRequest
     */
    spu_detail_html?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateGiftSpuRequest
     */
    spu_image_list?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateGiftSpuRequest
     */
    spu_main_image?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGiftSpuRequest
     */
    spu_name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGiftSpuRequest
     */
    spu_rich_text?: string;
}

/**
 * 
 * @export
 * @interface UpdateGiftSpuStatusRequest
 */
export interface UpdateGiftSpuStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateGiftSpuStatusRequest
     */
    spu_status: UpdateGiftSpuStatusRequest.SpuStatusEnum;
}

/**
 * @export
 * @namespace UpdateGiftSpuStatusRequest
 */
export namespace UpdateGiftSpuStatusRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum SpuStatusEnum {
        ENABLED = <any> 'ENABLED',
        DISABLED = <any> 'DISABLED'
    }
}

/**
 * 
 * @export
 * @interface UpdateInventoryByExternalSkuIdListRequest
 */
export interface UpdateInventoryByExternalSkuIdListRequest {
    /**
     * 
     * @type {Array<UpdateInventoryByExternalSkuIdRequest>}
     * @memberof UpdateInventoryByExternalSkuIdListRequest
     */
    records: Array<UpdateInventoryByExternalSkuIdRequest>;
}

/**
 * 
 * @export
 * @interface UpdateInventoryByExternalSkuIdListResponse
 */
export interface UpdateInventoryByExternalSkuIdListResponse {
    /**
     * 
     * @type {Array<UpdateInventoryByExternalSkuIdResponse>}
     * @memberof UpdateInventoryByExternalSkuIdListResponse
     */
    failed_records?: Array<UpdateInventoryByExternalSkuIdResponse>;
    /**
     * 
     * @type {number}
     * @memberof UpdateInventoryByExternalSkuIdListResponse
     */
    success_count?: number;
}

/**
 * 
 * @export
 * @interface UpdateInventoryByExternalSkuIdRequest
 */
export interface UpdateInventoryByExternalSkuIdRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateInventoryByExternalSkuIdRequest
     */
    external_sku_id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInventoryByExternalSkuIdRequest
     */
    external_spu_id?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateInventoryByExternalSkuIdRequest
     */
    inventory: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateInventoryByExternalSkuIdRequest
     */
    spu_id?: string;
}

/**
 * 
 * @export
 * @interface UpdateInventoryByExternalSkuIdResponse
 */
export interface UpdateInventoryByExternalSkuIdResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateInventoryByExternalSkuIdResponse
     */
    error_message?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInventoryByExternalSkuIdResponse
     */
    external_sku_id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInventoryByExternalSkuIdResponse
     */
    external_spu_id?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateInventoryByExternalSkuIdResponse
     */
    inventory?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateInventoryByExternalSkuIdResponse
     */
    spu_id?: number;
}

/**
 * 
 * @export
 * @interface UpdateInventoryListRequest
 */
export interface UpdateInventoryListRequest {
    /**
     * 
     * @type {Array<UpdateInventoryRequest>}
     * @memberof UpdateInventoryListRequest
     */
    records: Array<UpdateInventoryRequest>;
}

/**
 * 
 * @export
 * @interface UpdateInventoryListResponse
 */
export interface UpdateInventoryListResponse {
    /**
     * 
     * @type {Array<UpdateInventoryResponse>}
     * @memberof UpdateInventoryListResponse
     */
    failed_records?: Array<UpdateInventoryResponse>;
    /**
     * 
     * @type {number}
     * @memberof UpdateInventoryListResponse
     */
    success_count?: number;
}

/**
 * 
 * @export
 * @interface UpdateInventoryRequest
 */
export interface UpdateInventoryRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateInventoryRequest
     */
    inventory: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateInventoryRequest
     */
    sku_id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInventoryRequest
     */
    spu_id: string;
}

/**
 * 
 * @export
 * @interface UpdateInventoryResponse
 */
export interface UpdateInventoryResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateInventoryResponse
     */
    error_message?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateInventoryResponse
     */
    inventory?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateInventoryResponse
     */
    sku_id?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateInventoryResponse
     */
    spu_id?: number;
}

/**
 * 
 * @export
 * @interface UpdatePresaleRequest
 */
export interface UpdatePresaleRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePresaleRequest
     */
    presale?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdatePresaleRequest
     */
    presale_end_action?: UpdatePresaleRequest.PresaleEndActionEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdatePresaleRequest
     */
    presale_end_at?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePresaleRequest
     */
    presale_start_at?: string;
}

/**
 * @export
 * @namespace UpdatePresaleRequest
 */
export namespace UpdatePresaleRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum PresaleEndActionEnum {
        UNKNOWN = <any> 'UNKNOWN',
        TRANSFERTONORMAL = <any> 'TRANSFER_TO_NORMAL',
        DISABLED = <any> 'DISABLED'
    }
}

/**
 * 
 * @export
 * @interface UpdatePurchaseLimitRequest
 */
export interface UpdatePurchaseLimitRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdatePurchaseLimitRequest
     */
    purchase_limit?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseLimitRequest
     */
    purchase_limit_status?: UpdatePurchaseLimitRequest.PurchaseLimitStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseLimitRequest
     */
    purchase_limit_type?: UpdatePurchaseLimitRequest.PurchaseLimitTypeEnum;
    /**
     * 
     * @type {Array<SkuPurchaseLimit1>}
     * @memberof UpdatePurchaseLimitRequest
     */
    sku_purchase_limit?: Array<SkuPurchaseLimit1>;
}

/**
 * @export
 * @namespace UpdatePurchaseLimitRequest
 */
export namespace UpdatePurchaseLimitRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum PurchaseLimitStatusEnum {
        DISABLED = <any> 'DISABLED',
        ENABLED = <any> 'ENABLED'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PurchaseLimitTypeEnum {
        DISABLED = <any> 'DISABLED',
        SPU = <any> 'SPU',
        SKU = <any> 'SKU'
    }
}

/**
 * 
 * @export
 * @interface UpdateSkuListRequest
 */
export interface UpdateSkuListRequest {
    /**
     * 
     * @type {Array<SkuRequest>}
     * @memberof UpdateSkuListRequest
     */
    sku_list: Array<SkuRequest>;
}

/**
 * 
 * @export
 * @interface UpdateSkuRequest
 */
export interface UpdateSkuRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateSkuRequest
     */
    cost_price?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateSkuRequest
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSkuRequest
     */
    external_sku_id?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateSkuRequest
     */
    inventory: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSkuRequest
     */
    is_enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateSkuRequest
     */
    market_price?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateSkuRequest
     */
    sell_price: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateSkuRequest
     */
    sku_code?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSkuRequest
     */
    sku_id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSkuRequest
     */
    sku_image?: string;
    /**
     * 
     * @type {Array<KeyValue>}
     * @memberof UpdateSkuRequest
     */
    variation_attributes_list?: Array<KeyValue>;
    /**
     * 
     * @type {number}
     * @memberof UpdateSkuRequest
     */
    volume?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateSkuRequest
     */
    volume_unit?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateSkuRequest
     */
    weight?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateSkuRequest
     */
    weight_unit?: string;
}

/**
 * 
 * @export
 * @interface UpdateSpuAttributeRequest
 */
export interface UpdateSpuAttributeRequest {
    /**
     * 
     * @type {Array<SpuAttributeBusiness>}
     * @memberof UpdateSpuAttributeRequest
     */
    attribute_list: Array<SpuAttributeBusiness>;
}

/**
 * 
 * @export
 * @interface UpdateSpuCategoryRequest
 */
export interface UpdateSpuCategoryRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSpuCategoryRequest
     */
    category_id_list?: Array<string>;
}

/**
 * 
 * @export
 * @interface UpdateSpuRequest
 */
export interface UpdateSpuRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSpuRequest
     */
    category_id_list?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateSpuRequest
     */
    main_video_media_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSpuRequest
     */
    presale?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateSpuRequest
     */
    presale_end_action?: UpdateSpuRequest.PresaleEndActionEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateSpuRequest
     */
    presale_end_at?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSpuRequest
     */
    presale_start_at?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSpuRequest
     */
    searchable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateSpuRequest
     */
    spu_code?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSpuRequest
     */
    spu_description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSpuRequest
     */
    spu_detail_html?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSpuRequest
     */
    spu_image_list?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateSpuRequest
     */
    spu_main_image?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSpuRequest
     */
    spu_name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSpuRequest
     */
    spu_rich_text?: string;
}

/**
 * @export
 * @namespace UpdateSpuRequest
 */
export namespace UpdateSpuRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum PresaleEndActionEnum {
        UNKNOWN = <any> 'UNKNOWN',
        TRANSFERTONORMAL = <any> 'TRANSFER_TO_NORMAL',
        DISABLED = <any> 'DISABLED'
    }
}

/**
 * 
 * @export
 * @interface UpdateSpuSortRequest
 */
export interface UpdateSpuSortRequest {
    /**
     * 
     * @type {Array<SpuSort>}
     * @memberof UpdateSpuSortRequest
     */
    spu_sort_list?: Array<SpuSort>;
}

/**
 * 
 * @export
 * @interface UpdateSpuStatusRequest
 */
export interface UpdateSpuStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateSpuStatusRequest
     */
    offline_at?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSpuStatusRequest
     */
    online_at?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSpuStatusRequest
     */
    spu_status: UpdateSpuStatusRequest.SpuStatusEnum;
}

/**
 * @export
 * @namespace UpdateSpuStatusRequest
 */
export namespace UpdateSpuStatusRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum SpuStatusEnum {
        ENABLED = <any> 'ENABLED',
        DISABLED = <any> 'DISABLED'
    }
}

/**
 * 
 * @export
 * @interface UpdateSpuVARequest
 */
export interface UpdateSpuVARequest {
    /**
     * 
     * @type {Array<SpuVariationAttributeBusiness>}
     * @memberof UpdateSpuVARequest
     */
    variation_attribute_list: Array<SpuVariationAttributeBusiness>;
}

/**
 * 
 * @export
 * @interface UpdateVariationAttributeRequest
 */
export interface UpdateVariationAttributeRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateVariationAttributeRequest
     */
    remark?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVariationAttributeRequest
     */
    variation_attribute_name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateVariationAttributeRequest
     */
    variation_attribute_value_list: Array<string>;
}

/**
 * 
 * @export
 * @interface VariationAttributeResponse
 */
export interface VariationAttributeResponse {
    /**
     * 
     * @type {string}
     * @memberof VariationAttributeResponse
     */
    catalog_id?: string;
    /**
     * 
     * @type {string}
     * @memberof VariationAttributeResponse
     */
    remark?: string;
    /**
     * 
     * @type {string}
     * @memberof VariationAttributeResponse
     */
    variation_attribute_id?: string;
    /**
     * 
     * @type {string}
     * @memberof VariationAttributeResponse
     */
    variation_attribute_name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof VariationAttributeResponse
     */
    variation_attribute_value_list?: Array<string>;
}




export interface IattributeDeleteParams {
  
  
  attribute_id: string, 
  
}
export interface IattributeDetailParams {
  
  
  attribute_id: string, 
  
}
export interface IattributeListParams {
  
  keyword?: string, 
  
  
}
export interface IattributeUpdateParams {
  update_attribute_request: UpdateAttributeRequest, 
  
  attribute_id: string, 
  
}
export interface IcreateAttributeParams {
  attribute_request: CreateAttributeRequest, 
  
  
  
}

/**
 *AttributeControllerApi - fetch parameter creator
 *@export
 */
export const AttributeControllerApiParamCreator = {
  /**
    *
    *@summary delete a specific attribute by attribute_id
    *@param {string} attribute_id 
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  attributeDelete(params = {} as IattributeDeleteParams, options: any = {}): FetchArgs {
    const {  attribute_id,    } = params

    // verify required path 'attribute_id' is not null or undefined
    if (attribute_id === null || attribute_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('attribute_id', 'Required parameter attribute_id was null or undefined when calling attributeDelete.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/attributes/{attribute_id}`.includes(prefix) ? `/business/v1/product/attributes/{attribute_id}` : prefix + `/business/v1/product/attributes/{attribute_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"attribute_id"}}`, encodeURIComponent(String(attribute_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'DELETE', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve a specific attribute value by attributed_id
    *@param {string} attribute_id 
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  attributeDetail(params = {} as IattributeDetailParams, options: any = {}): FetchArgs {
    const {  attribute_id,    } = params

    // verify required path 'attribute_id' is not null or undefined
    if (attribute_id === null || attribute_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('attribute_id', 'Required parameter attribute_id was null or undefined when calling attributeDetail.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/attributes/{attribute_id}`.includes(prefix) ? `/business/v1/product/attributes/{attribute_id}` : prefix + `/business/v1/product/attributes/{attribute_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"attribute_id"}}`, encodeURIComponent(String(attribute_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve a list of all attributes by keyword
    *@param {string} cookie 
    *@param {string} [keyword] keyword
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  attributeList(params = {} as IattributeListParams, options: any = {}): FetchArgs {
    const {   keyword,   } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/attributes`.includes(prefix) ? `/business/v1/product/attributes` : prefix + `/business/v1/product/attributes`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (keyword !== undefined) {
        localVarQueryParameter.keyword = keyword;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update a specific attribute by attributed_id
    *@param {string} attribute_id 
    *@param {string} cookie 
    *@param {UpdateAttributeRequest} update_attribute_request updateAttributeRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  attributeUpdate(params = {} as IattributeUpdateParams, options: any = {}): FetchArgs {
    const { update_attribute_request,  attribute_id,    } = params
    // verify required body 'update_attribute_request' is not null or undefined
    if (update_attribute_request === null || update_attribute_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('update_attribute_request', 'Required parameter update_attribute_request was null or undefined when calling attributeUpdate.');
    }

    // verify required path 'attribute_id' is not null or undefined
    if (attribute_id === null || attribute_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('attribute_id', 'Required parameter attribute_id was null or undefined when calling attributeUpdate.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/attributes/{attribute_id}`.includes(prefix) ? `/business/v1/product/attributes/{attribute_id}` : prefix + `/business/v1/product/attributes/{attribute_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"attribute_id"}}`, encodeURIComponent(String(attribute_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PUT', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateAttributeRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(update_attribute_request || {}) : (update_attribute_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary create a new attribute
    *@param {string} cookie 
    *@param {CreateAttributeRequest} attribute_request attributeRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  createAttribute(params = {} as IcreateAttributeParams, options: any = {}): FetchArgs {
    const { attribute_request,     } = params
    // verify required body 'attribute_request' is not null or undefined
    if (attribute_request === null || attribute_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('attribute_request', 'Required parameter attribute_request was null or undefined when calling createAttribute.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/attributes`.includes(prefix) ? `/business/v1/product/attributes` : prefix + `/business/v1/product/attributes`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"CreateAttributeRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(attribute_request || {}) : (attribute_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IcategoryAttributeByIdsParams {
  
  category_id_list?: string, 
  
  
}
export interface IcategoryAttributeCreateParams {
  category_attribute_request: CategoryAttributeRequest, 
  
  category_id: string, 
  
}
export interface IcategoryAttributeDeleteParams {
  
  
  attribute_id: string, category_id: string, 
  
}
export interface IcategoryAttributeGetParams {
  
  
  category_id: string, 
  
}
export interface IcategoryAttributeUpdateParams {
  request: PatchUpdateFilterRequest, 
  
  category_attribute_id: string, category_id: string, 
  
}

/**
 *CategoryAttributeControllerApi - fetch parameter creator
 *@export
 */
export const CategoryAttributeControllerApiParamCreator = {
  /**
    *
    *@summary retrieve all attributes by category id list
    *@param {string} cookie 
    *@param {string} [category_id_list] category_id_list
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  categoryAttributeByIds(params = {} as IcategoryAttributeByIdsParams, options: any = {}): FetchArgs {
    const {   category_id_list,   } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/categories/attributes`.includes(prefix) ? `/business/v1/product/categories/attributes` : prefix + `/business/v1/product/categories/attributes`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (category_id_list !== undefined) {
        localVarQueryParameter.category_id_list = category_id_list;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary create a new relationship between a specific attribute and a specific category
    *@param {string} category_id 
    *@param {string} cookie 
    *@param {CategoryAttributeRequest} category_attribute_request categoryAttributeRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  categoryAttributeCreate(params = {} as IcategoryAttributeCreateParams, options: any = {}): FetchArgs {
    const { category_attribute_request,  category_id,    } = params
    // verify required body 'category_attribute_request' is not null or undefined
    if (category_attribute_request === null || category_attribute_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('category_attribute_request', 'Required parameter category_attribute_request was null or undefined when calling categoryAttributeCreate.');
    }

    // verify required path 'category_id' is not null or undefined
    if (category_id === null || category_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('category_id', 'Required parameter category_id was null or undefined when calling categoryAttributeCreate.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/categories/{category_id}/attributes`.includes(prefix) ? `/business/v1/product/categories/{category_id}/attributes` : prefix + `/business/v1/product/categories/{category_id}/attributes`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"category_id"}}`, encodeURIComponent(String(category_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"CategoryAttributeRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(category_attribute_request || {}) : (category_attribute_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary delete the relationship between a specific attribute and a specific category
    *@param {string} attribute_id 
    *@param {string} category_id 
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  categoryAttributeDelete(params = {} as IcategoryAttributeDeleteParams, options: any = {}): FetchArgs {
    const {  attribute_id, category_id,    } = params

    // verify required path 'attribute_id' is not null or undefined
    if (attribute_id === null || attribute_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('attribute_id', 'Required parameter attribute_id was null or undefined when calling categoryAttributeDelete.');
    }
    // verify required path 'category_id' is not null or undefined
    if (category_id === null || category_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('category_id', 'Required parameter category_id was null or undefined when calling categoryAttributeDelete.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/categories/{category_id}/attributes/{attribute_id}`.includes(prefix) ? `/business/v1/product/categories/{category_id}/attributes/{attribute_id}` : prefix + `/business/v1/product/categories/{category_id}/attributes/{attribute_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"attribute_id"}}`, encodeURIComponent(String(attribute_id)))
        .replace(`{${"category_id"}}`, encodeURIComponent(String(category_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'DELETE', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve all attributes related to a specific category
    *@param {string} category_id 
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  categoryAttributeGet(params = {} as IcategoryAttributeGetParams, options: any = {}): FetchArgs {
    const {  category_id,    } = params

    // verify required path 'category_id' is not null or undefined
    if (category_id === null || category_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('category_id', 'Required parameter category_id was null or undefined when calling categoryAttributeGet.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/categories/{category_id}/attributes`.includes(prefix) ? `/business/v1/product/categories/{category_id}/attributes` : prefix + `/business/v1/product/categories/{category_id}/attributes`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"category_id"}}`, encodeURIComponent(String(category_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update category attribute filter value by category attribute id
    *@param {string} category_attribute_id 
    *@param {string} category_id 
    *@param {string} cookie 
    *@param {PatchUpdateFilterRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  categoryAttributeUpdate(params = {} as IcategoryAttributeUpdateParams, options: any = {}): FetchArgs {
    const { request,  category_attribute_id, category_id,    } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling categoryAttributeUpdate.');
    }

    // verify required path 'category_attribute_id' is not null or undefined
    if (category_attribute_id === null || category_attribute_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('category_attribute_id', 'Required parameter category_attribute_id was null or undefined when calling categoryAttributeUpdate.');
    }
    // verify required path 'category_id' is not null or undefined
    if (category_id === null || category_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('category_id', 'Required parameter category_id was null or undefined when calling categoryAttributeUpdate.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/categories/{category_id}/category_attributes/{category_attribute_id}`.includes(prefix) ? `/business/v1/product/categories/{category_id}/category_attributes/{category_attribute_id}` : prefix + `/business/v1/product/categories/{category_id}/category_attributes/{category_attribute_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"category_attribute_id"}}`, encodeURIComponent(String(category_attribute_id)))
        .replace(`{${"category_id"}}`, encodeURIComponent(String(category_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"PatchUpdateFilterRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IcategoryCreateParams {
  create_category_request: CreateCategoryRequest, 
  
  
  
}
export interface IcategoryDetailParams {
  
  
  category_id: string, 
  
}
export interface IdeleteCategoryParams {
  
  
  category_id: string, 
  
}
export interface IgetAllCategoryParams {
  
  enabled?: boolean, 
  
  
}
export interface IgetCategoriesByCategoryIdListParams {
  
  category_id_list?: string, 
  
  
}
export interface IgetChildCategoriesByCategoryIdParams {
  
  
  category_id: number, 
  
}
export interface IoptionalUpdateCategoryParams {
  optional_update_category_request: OptionalUpdateCategoryRequest, 
  
  category_id: string, 
  
}
export interface IupdateCategoryParams {
  update_category_request: UpdateCategoryRequest, 
  
  category_id: string, 
  
}
export interface IupdateCategorySortingParams {
  req: UpdateCategoriesSortingRequest, 
  
  
  
}

/**
 *CategoryControllerApi - fetch parameter creator
 *@export
 */
export const CategoryControllerApiParamCreator = {
  /**
    *
    *@summary create a new category
    *@param {string} cookie 
    *@param {CreateCategoryRequest} create_category_request createCategoryRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  categoryCreate(params = {} as IcategoryCreateParams, options: any = {}): FetchArgs {
    const { create_category_request,     } = params
    // verify required body 'create_category_request' is not null or undefined
    if (create_category_request === null || create_category_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('create_category_request', 'Required parameter create_category_request was null or undefined when calling categoryCreate.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/categories`.includes(prefix) ? `/business/v1/product/categories` : prefix + `/business/v1/product/categories`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"CreateCategoryRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(create_category_request || {}) : (create_category_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve a specific category by categoryId
    *@param {string} category_id 
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  categoryDetail(params = {} as IcategoryDetailParams, options: any = {}): FetchArgs {
    const {  category_id,    } = params

    // verify required path 'category_id' is not null or undefined
    if (category_id === null || category_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('category_id', 'Required parameter category_id was null or undefined when calling categoryDetail.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/categories/{category_id}`.includes(prefix) ? `/business/v1/product/categories/{category_id}` : prefix + `/business/v1/product/categories/{category_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"category_id"}}`, encodeURIComponent(String(category_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary delete a specific category by categoryId
    *@param {string} category_id 
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  deleteCategory(params = {} as IdeleteCategoryParams, options: any = {}): FetchArgs {
    const {  category_id,    } = params

    // verify required path 'category_id' is not null or undefined
    if (category_id === null || category_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('category_id', 'Required parameter category_id was null or undefined when calling deleteCategory.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/categories/{category_id}`.includes(prefix) ? `/business/v1/product/categories/{category_id}` : prefix + `/business/v1/product/categories/{category_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"category_id"}}`, encodeURIComponent(String(category_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'DELETE', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve the list of the categories
    *@param {string} cookie 
    *@param {boolean} [enabled] enabled
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getAllCategory(params = {} as IgetAllCategoryParams, options: any = {}): FetchArgs {
    const {   enabled,   } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/categories/list`.includes(prefix) ? `/business/v1/product/categories/list` : prefix + `/business/v1/product/categories/list`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (enabled !== undefined) {
        localVarQueryParameter.enabled = enabled;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve the list of the categories by category id list
    *@param {string} cookie 
    *@param {string} [category_id_list] category_id_list
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getCategoriesByCategoryIdList(params = {} as IgetCategoriesByCategoryIdListParams, options: any = {}): FetchArgs {
    const {   category_id_list,   } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/categories`.includes(prefix) ? `/business/v1/product/categories` : prefix + `/business/v1/product/categories`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (category_id_list !== undefined) {
        localVarQueryParameter.category_id_list = category_id_list;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve the list of the child categories by category id
    *@param {string} cookie 
    *@param {number} category_id category_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getChildCategoriesByCategoryId(params = {} as IgetChildCategoriesByCategoryIdParams, options: any = {}): FetchArgs {
    const {  category_id,    } = params

    // verify required path 'category_id' is not null or undefined
    if (category_id === null || category_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('category_id', 'Required parameter category_id was null or undefined when calling getChildCategoriesByCategoryId.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/categories/{category_id}/children`.includes(prefix) ? `/business/v1/product/categories/{category_id}/children` : prefix + `/business/v1/product/categories/{category_id}/children`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"category_id"}}`, encodeURIComponent(String(category_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update optional detail of a specific category by categoryId
    *@param {string} category_id 
    *@param {string} cookie 
    *@param {OptionalUpdateCategoryRequest} optional_update_category_request optionalUpdateCategoryRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  optionalUpdateCategory(params = {} as IoptionalUpdateCategoryParams, options: any = {}): FetchArgs {
    const { optional_update_category_request,  category_id,    } = params
    // verify required body 'optional_update_category_request' is not null or undefined
    if (optional_update_category_request === null || optional_update_category_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('optional_update_category_request', 'Required parameter optional_update_category_request was null or undefined when calling optionalUpdateCategory.');
    }

    // verify required path 'category_id' is not null or undefined
    if (category_id === null || category_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('category_id', 'Required parameter category_id was null or undefined when calling optionalUpdateCategory.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/categories/{category_id}`.includes(prefix) ? `/business/v1/product/categories/{category_id}` : prefix + `/business/v1/product/categories/{category_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"category_id"}}`, encodeURIComponent(String(category_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"OptionalUpdateCategoryRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(optional_update_category_request || {}) : (optional_update_category_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update a specific category by categoryId
    *@param {string} category_id 
    *@param {string} cookie 
    *@param {UpdateCategoryRequest} update_category_request updateCategoryRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateCategory(params = {} as IupdateCategoryParams, options: any = {}): FetchArgs {
    const { update_category_request,  category_id,    } = params
    // verify required body 'update_category_request' is not null or undefined
    if (update_category_request === null || update_category_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('update_category_request', 'Required parameter update_category_request was null or undefined when calling updateCategory.');
    }

    // verify required path 'category_id' is not null or undefined
    if (category_id === null || category_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('category_id', 'Required parameter category_id was null or undefined when calling updateCategory.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/categories/{category_id}`.includes(prefix) ? `/business/v1/product/categories/{category_id}` : prefix + `/business/v1/product/categories/{category_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"category_id"}}`, encodeURIComponent(String(category_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PUT', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateCategoryRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(update_category_request || {}) : (update_category_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update categories sorting
    *@param {string} cookie 
    *@param {UpdateCategoriesSortingRequest} req req
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateCategorySorting(params = {} as IupdateCategorySortingParams, options: any = {}): FetchArgs {
    const { req,     } = params
    // verify required body 'req' is not null or undefined
    if (req === null || req === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('req', 'Required parameter req was null or undefined when calling updateCategorySorting.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/categories/sorting`.includes(prefix) ? `/business/v1/product/categories/sorting` : prefix + `/business/v1/product/categories/sorting`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PUT', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateCategoriesSortingRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(req || {}) : (req || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IcategoryExternalDetailParams {
  
  
  external_category_id: string, 
  
}
export interface IdeleteCategoryExternalParams {
  
  
  external_category_id: string, 
  
}
export interface IupdateCategoryExternalParams {
  update_category_request: UpdateCategoryRequest, 
  
  external_category_id: string, 
  
}

/**
 *CategoryExternalControllerApi - fetch parameter creator
 *@export
 */
export const CategoryExternalControllerApiParamCreator = {
  /**
    *
    *@summary retrieve a specific category by external_category_id
    *@param {string} cookie 
    *@param {string} external_category_id external_category_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  categoryExternalDetail(params = {} as IcategoryExternalDetailParams, options: any = {}): FetchArgs {
    const {  external_category_id,    } = params

    // verify required path 'external_category_id' is not null or undefined
    if (external_category_id === null || external_category_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('external_category_id', 'Required parameter external_category_id was null or undefined when calling categoryExternalDetail.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/categories/external/{external_category_id}`.includes(prefix) ? `/business/v1/product/categories/external/{external_category_id}` : prefix + `/business/v1/product/categories/external/{external_category_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"external_category_id"}}`, encodeURIComponent(String(external_category_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary delete a specific category by external_category_id
    *@param {string} cookie 
    *@param {string} external_category_id external_category_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  deleteCategoryExternal(params = {} as IdeleteCategoryExternalParams, options: any = {}): FetchArgs {
    const {  external_category_id,    } = params

    // verify required path 'external_category_id' is not null or undefined
    if (external_category_id === null || external_category_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('external_category_id', 'Required parameter external_category_id was null or undefined when calling deleteCategoryExternal.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/categories/external/{external_category_id}`.includes(prefix) ? `/business/v1/product/categories/external/{external_category_id}` : prefix + `/business/v1/product/categories/external/{external_category_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"external_category_id"}}`, encodeURIComponent(String(external_category_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'DELETE', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update a specific category by external_category_id
    *@param {string} cookie 
    *@param {string} external_category_id external_category_id
    *@param {UpdateCategoryRequest} update_category_request updateCategoryRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateCategoryExternal(params = {} as IupdateCategoryExternalParams, options: any = {}): FetchArgs {
    const { update_category_request,  external_category_id,    } = params
    // verify required body 'update_category_request' is not null or undefined
    if (update_category_request === null || update_category_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('update_category_request', 'Required parameter update_category_request was null or undefined when calling updateCategoryExternal.');
    }

    // verify required path 'external_category_id' is not null or undefined
    if (external_category_id === null || external_category_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('external_category_id', 'Required parameter external_category_id was null or undefined when calling updateCategoryExternal.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/categories/external/{external_category_id}`.includes(prefix) ? `/business/v1/product/categories/external/{external_category_id}` : prefix + `/business/v1/product/categories/external/{external_category_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"external_category_id"}}`, encodeURIComponent(String(external_category_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PUT', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateCategoryRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(update_category_request || {}) : (update_category_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IcategoryVariationAttributeDetailParams {
  
  
  category_id: string, 
  
}
export interface IcreateCategoryVariationAttributeParams {
  category_variation_attribute_request: CategoryVariationAttributeRequest, 
  
  category_id: string, 
  
}
export interface IdeleteCategoryVariationAttributeParams {
  
  
  category_id: number, variation_attribute_id: number, 
  
}
export interface IgetCategoriesVariationAttributeParams {
  
  category_id_list?: string, 
  
  
}
export interface IupdateCategoryVariationAttributeParams {
  request: PatchUpdateFilterRequest, 
  
  category_id: string, category_variation_attribute_id: string, 
  
}

/**
 *CategoryVariationAttributeControllerApi - fetch parameter creator
 *@export
 */
export const CategoryVariationAttributeControllerApiParamCreator = {
  /**
    *
    *@summary retrieve all variation attributes related to a specific category
    *@param {string} category_id 
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  categoryVariationAttributeDetail(params = {} as IcategoryVariationAttributeDetailParams, options: any = {}): FetchArgs {
    const {  category_id,    } = params

    // verify required path 'category_id' is not null or undefined
    if (category_id === null || category_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('category_id', 'Required parameter category_id was null or undefined when calling categoryVariationAttributeDetail.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/categories/{category_id}/variation_attributes`.includes(prefix) ? `/business/v1/product/categories/{category_id}/variation_attributes` : prefix + `/business/v1/product/categories/{category_id}/variation_attributes`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"category_id"}}`, encodeURIComponent(String(category_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary create a new relationship between a specific variation attribute and a specific category
    *@param {string} category_id 
    *@param {string} cookie 
    *@param {CategoryVariationAttributeRequest} category_variation_attribute_request categoryVariationAttributeRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  createCategoryVariationAttribute(params = {} as IcreateCategoryVariationAttributeParams, options: any = {}): FetchArgs {
    const { category_variation_attribute_request,  category_id,    } = params
    // verify required body 'category_variation_attribute_request' is not null or undefined
    if (category_variation_attribute_request === null || category_variation_attribute_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('category_variation_attribute_request', 'Required parameter category_variation_attribute_request was null or undefined when calling createCategoryVariationAttribute.');
    }

    // verify required path 'category_id' is not null or undefined
    if (category_id === null || category_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('category_id', 'Required parameter category_id was null or undefined when calling createCategoryVariationAttribute.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/categories/{category_id}/variation_attributes`.includes(prefix) ? `/business/v1/product/categories/{category_id}/variation_attributes` : prefix + `/business/v1/product/categories/{category_id}/variation_attributes`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"category_id"}}`, encodeURIComponent(String(category_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"CategoryVariationAttributeRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(category_variation_attribute_request || {}) : (category_variation_attribute_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary remove a variation attribute and category relationship, just the relationship, not the variation attribute itself
    *@param {string} cookie 
    *@param {number} category_id category_id
    *@param {number} variation_attribute_id variation_attribute_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  deleteCategoryVariationAttribute(params = {} as IdeleteCategoryVariationAttributeParams, options: any = {}): FetchArgs {
    const {  category_id, variation_attribute_id,    } = params

    // verify required path 'category_id' is not null or undefined
    if (category_id === null || category_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('category_id', 'Required parameter category_id was null or undefined when calling deleteCategoryVariationAttribute.');
    }
    // verify required path 'variation_attribute_id' is not null or undefined
    if (variation_attribute_id === null || variation_attribute_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('variation_attribute_id', 'Required parameter variation_attribute_id was null or undefined when calling deleteCategoryVariationAttribute.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/categories/{category_id}/variation_attributes/{variation_attribute_id}`.includes(prefix) ? `/business/v1/product/categories/{category_id}/variation_attributes/{variation_attribute_id}` : prefix + `/business/v1/product/categories/{category_id}/variation_attributes/{variation_attribute_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"category_id"}}`, encodeURIComponent(String(category_id)))
        .replace(`{${"variation_attribute_id"}}`, encodeURIComponent(String(variation_attribute_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'DELETE', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve all variation attributes by category id list
    *@param {string} cookie 
    *@param {string} [category_id_list] category_id_list
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getCategoriesVariationAttribute(params = {} as IgetCategoriesVariationAttributeParams, options: any = {}): FetchArgs {
    const {   category_id_list,   } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/categories/variation_attributes`.includes(prefix) ? `/business/v1/product/categories/variation_attributes` : prefix + `/business/v1/product/categories/variation_attributes`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (category_id_list !== undefined) {
        localVarQueryParameter.category_id_list = category_id_list;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update category variation attribute filter value by category variation attribute id
    *@param {string} category_id 
    *@param {string} category_variation_attribute_id 
    *@param {string} cookie 
    *@param {PatchUpdateFilterRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateCategoryVariationAttribute(params = {} as IupdateCategoryVariationAttributeParams, options: any = {}): FetchArgs {
    const { request,  category_id, category_variation_attribute_id,    } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updateCategoryVariationAttribute.');
    }

    // verify required path 'category_id' is not null or undefined
    if (category_id === null || category_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('category_id', 'Required parameter category_id was null or undefined when calling updateCategoryVariationAttribute.');
    }
    // verify required path 'category_variation_attribute_id' is not null or undefined
    if (category_variation_attribute_id === null || category_variation_attribute_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('category_variation_attribute_id', 'Required parameter category_variation_attribute_id was null or undefined when calling updateCategoryVariationAttribute.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/categories/{category_id}/category_variation_attributes/{category_variation_attribute_id}`.includes(prefix) ? `/business/v1/product/categories/{category_id}/category_variation_attributes/{category_variation_attribute_id}` : prefix + `/business/v1/product/categories/{category_id}/category_variation_attributes/{category_variation_attribute_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"category_id"}}`, encodeURIComponent(String(category_id)))
        .replace(`{${"category_variation_attribute_id"}}`, encodeURIComponent(String(category_variation_attribute_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"PatchUpdateFilterRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IgetGiftAllSkuParams {
  
  show_real_inventory?: boolean, 
  spu_id: string, 
  
}
export interface IgetGiftSkuInventoryParams {
  
  sku_id?: number, sku_inventory_type: 'CURRENT' | 'LOCKED', 
  spu_id: string, 
  
}
export interface IupdateBatchGiftSkuInventoryParams {
  request: UpdateInventoryListRequest, 
  
  
  
}
export interface IupdateGiftSkuParams {
  sku_list_request: SkuListRequest, 
  
  spu_id: string, 
  
}
export interface IupdateGiftSkuInventoryParams {
  sku_inventory_request: SkuInventoryRequest, 
  
  sku_id: string, spu_id: string, 
  
}
export interface IupdateGiftSkuStatusParams {
  sku_status_request: SkuStatusRequest, 
  
  sku_id: string, spu_id: string, 
  
}

/**
 *GiftSkuControllerApi - fetch parameter creator
 *@export
 */
export const GiftSkuControllerApiParamCreator = {
  /**
    *
    *@summary retrieve the gift sku list with full info of a specific gift spu by spu_id
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {boolean} [show_real_inventory] show_real_inventory
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getGiftAllSku(params = {} as IgetGiftAllSkuParams, options: any = {}): FetchArgs {
    const {  spu_id,  show_real_inventory,   } = params

    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling getGiftAllSku.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/gifts/{spu_id}/skus`.includes(prefix) ? `/business/v1/product/gifts/{spu_id}/skus` : prefix + `/business/v1/product/gifts/{spu_id}/skus`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (show_real_inventory !== undefined) {
        localVarQueryParameter.show_real_inventory = show_real_inventory;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve the gift sku inventory list of a specific spu by spu_id
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {'CURRENT' | 'LOCKED'} sku_inventory_type sku_inventory_type
    *@param {number} [sku_id] sku_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getGiftSkuInventory(params = {} as IgetGiftSkuInventoryParams, options: any = {}): FetchArgs {
    const {  spu_id,  sku_id, sku_inventory_type,   } = params

    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling getGiftSkuInventory.');
    }

    // verify required query 'sku_inventory_type' is not null or undefined
    if (sku_inventory_type === null || sku_inventory_type === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('sku_inventory_type', 'Required parameter sku_inventory_type was null or undefined when calling getGiftSkuInventory.');
    }

    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/gifts/{spu_id}/skus/inventory`.includes(prefix) ? `/business/v1/product/gifts/{spu_id}/skus/inventory` : prefix + `/business/v1/product/gifts/{spu_id}/skus/inventory`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (sku_id !== undefined) {
        localVarQueryParameter.sku_id = sku_id;
    }

    if (sku_inventory_type !== undefined) {
        localVarQueryParameter.sku_inventory_type = sku_inventory_type;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary batch update gift sku inventory by spu_id and sku_id
    *@param {string} cookie 
    *@param {UpdateInventoryListRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateBatchGiftSkuInventory(params = {} as IupdateBatchGiftSkuInventoryParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updateBatchGiftSkuInventory.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/gifts/skus/inventory/batch`.includes(prefix) ? `/business/v1/product/gifts/skus/inventory/batch` : prefix + `/business/v1/product/gifts/skus/inventory/batch`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PUT', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateInventoryListRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update the gift sku list for a specific gift spu by spu_id
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {SkuListRequest} sku_list_request skuListRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateGiftSku(params = {} as IupdateGiftSkuParams, options: any = {}): FetchArgs {
    const { sku_list_request,  spu_id,    } = params
    // verify required body 'sku_list_request' is not null or undefined
    if (sku_list_request === null || sku_list_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('sku_list_request', 'Required parameter sku_list_request was null or undefined when calling updateGiftSku.');
    }

    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling updateGiftSku.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/gifts/{spu_id}/skus`.includes(prefix) ? `/business/v1/product/gifts/{spu_id}/skus` : prefix + `/business/v1/product/gifts/{spu_id}/skus`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"SkuListRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(sku_list_request || {}) : (sku_list_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update gift sku inventory by spu_id and sku_id
    *@param {string} sku_id 
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {SkuInventoryRequest} sku_inventory_request skuInventoryRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateGiftSkuInventory(params = {} as IupdateGiftSkuInventoryParams, options: any = {}): FetchArgs {
    const { sku_inventory_request,  sku_id, spu_id,    } = params
    // verify required body 'sku_inventory_request' is not null or undefined
    if (sku_inventory_request === null || sku_inventory_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('sku_inventory_request', 'Required parameter sku_inventory_request was null or undefined when calling updateGiftSkuInventory.');
    }

    // verify required path 'sku_id' is not null or undefined
    if (sku_id === null || sku_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('sku_id', 'Required parameter sku_id was null or undefined when calling updateGiftSkuInventory.');
    }
    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling updateGiftSkuInventory.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/gifts/{spu_id}/skus/{sku_id}/inventory`.includes(prefix) ? `/business/v1/product/gifts/{spu_id}/skus/{sku_id}/inventory` : prefix + `/business/v1/product/gifts/{spu_id}/skus/{sku_id}/inventory`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"sku_id"}}`, encodeURIComponent(String(sku_id)))
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"SkuInventoryRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(sku_inventory_request || {}) : (sku_inventory_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update the status of a specific gift sku by spu_id and related sku_id
    *@param {string} sku_id 
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {SkuStatusRequest} sku_status_request skuStatusRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateGiftSkuStatus(params = {} as IupdateGiftSkuStatusParams, options: any = {}): FetchArgs {
    const { sku_status_request,  sku_id, spu_id,    } = params
    // verify required body 'sku_status_request' is not null or undefined
    if (sku_status_request === null || sku_status_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('sku_status_request', 'Required parameter sku_status_request was null or undefined when calling updateGiftSkuStatus.');
    }

    // verify required path 'sku_id' is not null or undefined
    if (sku_id === null || sku_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('sku_id', 'Required parameter sku_id was null or undefined when calling updateGiftSkuStatus.');
    }
    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling updateGiftSkuStatus.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/gifts/{spu_id}/skus/{sku_id}/status`.includes(prefix) ? `/business/v1/product/gifts/{spu_id}/skus/{sku_id}/status` : prefix + `/business/v1/product/gifts/{spu_id}/skus/{sku_id}/status`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"sku_id"}}`, encodeURIComponent(String(sku_id)))
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"SkuStatusRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(sku_status_request || {}) : (sku_status_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IgetAllSkusParams {
  
  show_real_inventory?: boolean, 
  external_spu_id: string, 
  
}
export interface IgetGiftSkuInventoryByExternalParams {
  
  external_sku_id?: string, sku_inventory_type: 'CURRENT' | 'LOCKED', 
  spu_id: string, external_spu_id: string, 
  
}
export interface IupdateBatchGiftSkuInventory1Params {
  request: UpdateInventoryByExternalSkuIdListRequest, 
  
  
  
}
export interface IupdateGiftSkuInventory1Params {
  external_sku_inventory_request: ExternalSkuInventoryRequest, 
  
  external_sku_id: string, 
  
}
export interface IupdateSkusParams {
  sku_list_request: SkuListRequest, 
  
  external_spu_id: string, 
  
}

/**
 *GiftSkuExternalControllerApi - fetch parameter creator
 *@export
 */
export const GiftSkuExternalControllerApiParamCreator = {
  /**
    *
    *@summary retrieve the gift sku list with full info of a specific gift spu by external_spu_id
    *@param {string} cookie 
    *@param {string} external_spu_id external_spu_id
    *@param {boolean} [show_real_inventory] show_real_inventory
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getAllSkus(params = {} as IgetAllSkusParams, options: any = {}): FetchArgs {
    const {  external_spu_id,  show_real_inventory,   } = params

    // verify required path 'external_spu_id' is not null or undefined
    if (external_spu_id === null || external_spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('external_spu_id', 'Required parameter external_spu_id was null or undefined when calling getAllSkus.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/gifts/external/{external_spu_id}/skus`.includes(prefix) ? `/business/v1/product/gifts/external/{external_spu_id}/skus` : prefix + `/business/v1/product/gifts/external/{external_spu_id}/skus`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"external_spu_id"}}`, encodeURIComponent(String(external_spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (show_real_inventory !== undefined) {
        localVarQueryParameter.show_real_inventory = show_real_inventory;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve the gift sku inventory list of a specific spu by external_spu_id
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {string} external_spu_id external_spu_id
    *@param {'CURRENT' | 'LOCKED'} sku_inventory_type sku_inventory_type
    *@param {string} [external_sku_id] external_sku_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getGiftSkuInventoryByExternal(params = {} as IgetGiftSkuInventoryByExternalParams, options: any = {}): FetchArgs {
    const {  spu_id, external_spu_id,  external_sku_id, sku_inventory_type,   } = params

    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling getGiftSkuInventoryByExternal.');
    }
    // verify required path 'external_spu_id' is not null or undefined
    if (external_spu_id === null || external_spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('external_spu_id', 'Required parameter external_spu_id was null or undefined when calling getGiftSkuInventoryByExternal.');
    }

    // verify required query 'sku_inventory_type' is not null or undefined
    if (sku_inventory_type === null || sku_inventory_type === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('sku_inventory_type', 'Required parameter sku_inventory_type was null or undefined when calling getGiftSkuInventoryByExternal.');
    }

    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/gifts/external/{external_spu_id}/skus/inventory`.includes(prefix) ? `/business/v1/product/gifts/external/{external_spu_id}/skus/inventory` : prefix + `/business/v1/product/gifts/external/{external_spu_id}/skus/inventory`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)))
        .replace(`{${"external_spu_id"}}`, encodeURIComponent(String(external_spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (external_sku_id !== undefined) {
        localVarQueryParameter.external_sku_id = external_sku_id;
    }

    if (sku_inventory_type !== undefined) {
        localVarQueryParameter.sku_inventory_type = sku_inventory_type;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary batch update gift sku inventory by external_spu_id
    *@param {string} cookie 
    *@param {UpdateInventoryByExternalSkuIdListRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateBatchGiftSkuInventory1(params = {} as IupdateBatchGiftSkuInventory1Params, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updateBatchGiftSkuInventory1.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/gifts/external/skus/inventory/batch`.includes(prefix) ? `/business/v1/product/gifts/external/skus/inventory/batch` : prefix + `/business/v1/product/gifts/external/skus/inventory/batch`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PUT', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateInventoryByExternalSkuIdListRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update gift sku inventory by external_spu_id
    *@param {string} cookie 
    *@param {ExternalSkuInventoryRequest} external_sku_inventory_request externalSkuInventoryRequest
    *@param {string} external_sku_id external_sku_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateGiftSkuInventory1(params = {} as IupdateGiftSkuInventory1Params, options: any = {}): FetchArgs {
    const { external_sku_inventory_request,  external_sku_id,    } = params
    // verify required body 'external_sku_inventory_request' is not null or undefined
    if (external_sku_inventory_request === null || external_sku_inventory_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('external_sku_inventory_request', 'Required parameter external_sku_inventory_request was null or undefined when calling updateGiftSkuInventory1.');
    }

    // verify required path 'external_sku_id' is not null or undefined
    if (external_sku_id === null || external_sku_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('external_sku_id', 'Required parameter external_sku_id was null or undefined when calling updateGiftSkuInventory1.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/gifts/external/skus/{external_sku_id}/inventory`.includes(prefix) ? `/business/v1/product/gifts/external/skus/{external_sku_id}/inventory` : prefix + `/business/v1/product/gifts/external/skus/{external_sku_id}/inventory`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"external_sku_id"}}`, encodeURIComponent(String(external_sku_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"ExternalSkuInventoryRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(external_sku_inventory_request || {}) : (external_sku_inventory_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update the gift sku list for a specific gift spu by external_spu_id
    *@param {string} cookie 
    *@param {string} external_spu_id external_spu_id
    *@param {SkuListRequest} sku_list_request skuListRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateSkus(params = {} as IupdateSkusParams, options: any = {}): FetchArgs {
    const { sku_list_request,  external_spu_id,    } = params
    // verify required body 'sku_list_request' is not null or undefined
    if (sku_list_request === null || sku_list_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('sku_list_request', 'Required parameter sku_list_request was null or undefined when calling updateSkus.');
    }

    // verify required path 'external_spu_id' is not null or undefined
    if (external_spu_id === null || external_spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('external_spu_id', 'Required parameter external_spu_id was null or undefined when calling updateSkus.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/gifts/external/{external_spu_id}/skus`.includes(prefix) ? `/business/v1/product/gifts/external/{external_spu_id}/skus` : prefix + `/business/v1/product/gifts/external/{external_spu_id}/skus`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"external_spu_id"}}`, encodeURIComponent(String(external_spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"SkuListRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(sku_list_request || {}) : (sku_list_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IcreateGiftSpuParams {
  request: CreateGiftSpuRequest, 
  
  
  
}
export interface IdeleteGiftSpuParams {
  
  
  spu_id: string, 
  
}
export interface IgetGiftSpuDetailParams {
  
  
  spu_id: string, 
  
}
export interface IlistGiftsParams {
  
  keyword?: string, num?: number, page?: number, sku_type?: 'NONE' | 'SINGLE' | 'MULTIPLE', spu_status?: 'ENABLED' | 'DISABLED', 
  
  
}
export interface IupdateGiftSpuParams {
  request: UpdateGiftSpuRequest, 
  
  spu_id: string, 
  
}
export interface IupdateGiftSpuStatusParams {
  request: UpdateGiftSpuStatusRequest, 
  
  spu_id: string, 
  
}

/**
 *GiftSpuControllerApi - fetch parameter creator
 *@export
 */
export const GiftSpuControllerApiParamCreator = {
  /**
    *
    *@summary create a new gift spu
    *@param {string} cookie 
    *@param {CreateGiftSpuRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  createGiftSpu(params = {} as IcreateGiftSpuParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling createGiftSpu.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/gifts`.includes(prefix) ? `/business/v1/product/gifts` : prefix + `/business/v1/product/gifts`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"CreateGiftSpuRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary delete a specific gift spu by spu_id
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  deleteGiftSpu(params = {} as IdeleteGiftSpuParams, options: any = {}): FetchArgs {
    const {  spu_id,    } = params

    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling deleteGiftSpu.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/gifts/{spu_id}`.includes(prefix) ? `/business/v1/product/gifts/{spu_id}` : prefix + `/business/v1/product/gifts/{spu_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'DELETE', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve the full detail of a specific gift spu by spu_id
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getGiftSpuDetail(params = {} as IgetGiftSpuDetailParams, options: any = {}): FetchArgs {
    const {  spu_id,    } = params

    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling getGiftSpuDetail.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/gifts/{spu_id}`.includes(prefix) ? `/business/v1/product/gifts/{spu_id}` : prefix + `/business/v1/product/gifts/{spu_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve the basic info list of gift spu
    *@param {string} cookie 
    *@param {string} [keyword] keyword
    *@param {number} [num] num
    *@param {number} [page] page
    *@param {'NONE' | 'SINGLE' | 'MULTIPLE'} [sku_type] sku_type
    *@param {'ENABLED' | 'DISABLED'} [spu_status] spu_status
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  listGifts(params = {} as IlistGiftsParams, options: any = {}): FetchArgs {
    const {   keyword, num, page, sku_type, spu_status,   } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/gifts`.includes(prefix) ? `/business/v1/product/gifts` : prefix + `/business/v1/product/gifts`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (keyword !== undefined) {
        localVarQueryParameter.keyword = keyword;
    }

    if (num !== undefined) {
        localVarQueryParameter.num = num;
    }

    if (page !== undefined) {
        localVarQueryParameter.page = page;
    }

    if (sku_type !== undefined) {
        localVarQueryParameter.sku_type = sku_type;
    }

    if (spu_status !== undefined) {
        localVarQueryParameter.spu_status = spu_status;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update a specific gift spu by spu_id
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {UpdateGiftSpuRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateGiftSpu(params = {} as IupdateGiftSpuParams, options: any = {}): FetchArgs {
    const { request,  spu_id,    } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updateGiftSpu.');
    }

    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling updateGiftSpu.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/gifts/{spu_id}`.includes(prefix) ? `/business/v1/product/gifts/{spu_id}` : prefix + `/business/v1/product/gifts/{spu_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PUT', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateGiftSpuRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update the shelves status of a specific gift spu by spu_id
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {UpdateGiftSpuStatusRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateGiftSpuStatus(params = {} as IupdateGiftSpuStatusParams, options: any = {}): FetchArgs {
    const { request,  spu_id,    } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updateGiftSpuStatus.');
    }

    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling updateGiftSpuStatus.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/gifts/{spu_id}/spu_status`.includes(prefix) ? `/business/v1/product/gifts/{spu_id}/spu_status` : prefix + `/business/v1/product/gifts/{spu_id}/spu_status`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateGiftSpuStatusRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IdeleteExternalSpuParams {
  
  
  external_spu_id: string, 
  
}
export interface IexternalSpuDetailParams {
  
  
  external_spu_id: string, 
  
}
export interface IupdateExternalSpuParams {
  request: UpdateSpuRequest, 
  
  external_spu_id: string, 
  
}
export interface IupdateSpuStatusParams {
  request: UpdateSpuStatusRequest, 
  
  external_spu_id: string, 
  
}

/**
 *GiftSpuExternalControllerApi - fetch parameter creator
 *@export
 */
export const GiftSpuExternalControllerApiParamCreator = {
  /**
    *
    *@summary delete a specific gift spu by external_spu_id
    *@param {string} cookie 
    *@param {string} external_spu_id external_spu_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  deleteExternalSpu(params = {} as IdeleteExternalSpuParams, options: any = {}): FetchArgs {
    const {  external_spu_id,    } = params

    // verify required path 'external_spu_id' is not null or undefined
    if (external_spu_id === null || external_spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('external_spu_id', 'Required parameter external_spu_id was null or undefined when calling deleteExternalSpu.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/gifts/external/{external_spu_id}`.includes(prefix) ? `/business/v1/product/gifts/external/{external_spu_id}` : prefix + `/business/v1/product/gifts/external/{external_spu_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"external_spu_id"}}`, encodeURIComponent(String(external_spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'DELETE', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve the full detail of a specific gift spu by external_spu_id
    *@param {string} cookie 
    *@param {string} external_spu_id external_spu_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  externalSpuDetail(params = {} as IexternalSpuDetailParams, options: any = {}): FetchArgs {
    const {  external_spu_id,    } = params

    // verify required path 'external_spu_id' is not null or undefined
    if (external_spu_id === null || external_spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('external_spu_id', 'Required parameter external_spu_id was null or undefined when calling externalSpuDetail.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/gifts/external/{external_spu_id}`.includes(prefix) ? `/business/v1/product/gifts/external/{external_spu_id}` : prefix + `/business/v1/product/gifts/external/{external_spu_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"external_spu_id"}}`, encodeURIComponent(String(external_spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update a specific gift spu by external_spu_id
    *@param {string} cookie 
    *@param {string} external_spu_id external_spu_id
    *@param {UpdateSpuRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateExternalSpu(params = {} as IupdateExternalSpuParams, options: any = {}): FetchArgs {
    const { request,  external_spu_id,    } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updateExternalSpu.');
    }

    // verify required path 'external_spu_id' is not null or undefined
    if (external_spu_id === null || external_spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('external_spu_id', 'Required parameter external_spu_id was null or undefined when calling updateExternalSpu.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/gifts/external/{external_spu_id}`.includes(prefix) ? `/business/v1/product/gifts/external/{external_spu_id}` : prefix + `/business/v1/product/gifts/external/{external_spu_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"external_spu_id"}}`, encodeURIComponent(String(external_spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PUT', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateSpuRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update the shelves status of a specific gift spu by external_spu_id
    *@param {string} cookie 
    *@param {string} external_spu_id external_spu_id
    *@param {UpdateSpuStatusRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateSpuStatus(params = {} as IupdateSpuStatusParams, options: any = {}): FetchArgs {
    const { request,  external_spu_id,    } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updateSpuStatus.');
    }

    // verify required path 'external_spu_id' is not null or undefined
    if (external_spu_id === null || external_spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('external_spu_id', 'Required parameter external_spu_id was null or undefined when calling updateSpuStatus.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/gifts/external/{external_spu_id}/spu_status`.includes(prefix) ? `/business/v1/product/gifts/external/{external_spu_id}/spu_status` : prefix + `/business/v1/product/gifts/external/{external_spu_id}/spu_status`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"external_spu_id"}}`, encodeURIComponent(String(external_spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateSpuStatusRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IbatchApproveParams {
  request: Array<ApproveReviewRequest>, 
  
  
  
}
export interface IbatchDisplayParams {
  request: Array<DisplayReviewRequest>, 
  
  
  
}
export interface IreviewDetailParams {
  
  
  review_id: string, 
  
}
export interface IreviewListParams {
  
  approved_status?: 'PENDING' | 'APPROVED' | 'REJECTED', channel?: string, created_at_from?: string, created_at_to?: string, review_display?: 'HIDDEN' | 'VISIBLE', sku_id?: string, spu_id?: string, spu_name?: string, storefront_id?: string, num?: number, page?: number, 
  
  
}

/**
 *ReviewApprovalControllerApi - fetch parameter creator
 *@export
 */
export const ReviewApprovalControllerApiParamCreator = {
  /**
    *
    *@summary batch approve reviews
    *@param {string} cookie 
    *@param {Array<ApproveReviewRequest>} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  batchApprove(params = {} as IbatchApproveParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling batchApprove.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/reviews/approve`.includes(prefix) ? `/business/v1/product/reviews/approve` : prefix + `/business/v1/product/reviews/approve`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"Array&lt;ApproveReviewRequest&gt;" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary batch display reviews
    *@param {string} cookie 
    *@param {Array<DisplayReviewRequest>} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  batchDisplay(params = {} as IbatchDisplayParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling batchDisplay.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/reviews/display`.includes(prefix) ? `/business/v1/product/reviews/display` : prefix + `/business/v1/product/reviews/display`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"Array&lt;DisplayReviewRequest&gt;" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve the detail of a specific review by review_id
    *@param {string} review_id 
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  reviewDetail(params = {} as IreviewDetailParams, options: any = {}): FetchArgs {
    const {  review_id,    } = params

    // verify required path 'review_id' is not null or undefined
    if (review_id === null || review_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('review_id', 'Required parameter review_id was null or undefined when calling reviewDetail.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/reviews/{review_id}`.includes(prefix) ? `/business/v1/product/reviews/{review_id}` : prefix + `/business/v1/product/reviews/{review_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"review_id"}}`, encodeURIComponent(String(review_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve the list of the reviews
    *@param {string} cookie 
    *@param {'PENDING' | 'APPROVED' | 'REJECTED'} [approved_status] 
    *@param {string} [channel] 
    *@param {string} [created_at_from] 
    *@param {string} [created_at_to] 
    *@param {'HIDDEN' | 'VISIBLE'} [review_display] 
    *@param {string} [sku_id] 
    *@param {string} [spu_id] 
    *@param {string} [spu_name] 
    *@param {string} [storefront_id] 
    *@param {number} [num] 
    *@param {number} [page] 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  reviewList(params = {} as IreviewListParams, options: any = {}): FetchArgs {
    const {   approved_status, channel, created_at_from, created_at_to, review_display, sku_id, spu_id, spu_name, storefront_id, num, page,   } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/reviews`.includes(prefix) ? `/business/v1/product/reviews` : prefix + `/business/v1/product/reviews`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (approved_status !== undefined) {
        localVarQueryParameter.approved_status = approved_status;
    }

    if (channel !== undefined) {
        localVarQueryParameter.channel = channel;
    }

    if (created_at_from !== undefined) {
        localVarQueryParameter.created_at_from = created_at_from;
    }

    if (created_at_to !== undefined) {
        localVarQueryParameter.created_at_to = created_at_to;
    }

    if (review_display !== undefined) {
        localVarQueryParameter.review_display = review_display;
    }

    if (sku_id !== undefined) {
        localVarQueryParameter.sku_id = sku_id;
    }

    if (spu_id !== undefined) {
        localVarQueryParameter.spu_id = spu_id;
    }

    if (spu_name !== undefined) {
        localVarQueryParameter.spu_name = spu_name;
    }

    if (storefront_id !== undefined) {
        localVarQueryParameter.storefront_id = storefront_id;
    }

    if (num !== undefined) {
        localVarQueryParameter.num = num;
    }

    if (page !== undefined) {
        localVarQueryParameter.page = page;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IgetAllSkus1Params {
  
  show_real_inventory?: boolean, 
  spu_id: string, 
  
}
export interface IgetSkuInventoryParams {
  
  sku_id?: number, sku_inventory_type: 'CURRENT' | 'LOCKED', 
  spu_id: string, 
  
}
export interface IupdateBatchSkuInventoryParams {
  request: UpdateInventoryListRequest, 
  
  
  
}
export interface IupdateSkuInventoryParams {
  sku_inventory_request: SkuInventoryRequest, 
  
  sku_id: string, spu_id: string, 
  
}
export interface IupdateSkuStatusParams {
  sku_status_request: SkuStatusRequest, 
  
  sku_id: string, spu_id: string, 
  
}
export interface IupdateSkulistParams {
  request: UpdateSkuListRequest, 
  
  spu_id: string, 
  
}
export interface IupdateSkus1Params {
  sku_list_request: SkuListRequest, 
  
  spu_id: string, 
  
}

/**
 *SkuControllerApi - fetch parameter creator
 *@export
 */
export const SkuControllerApiParamCreator = {
  /**
    *
    *@summary retrieve the sku list with full info of a specific spu by spu_id
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {boolean} [show_real_inventory] show_real_inventory
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getAllSkus1(params = {} as IgetAllSkus1Params, options: any = {}): FetchArgs {
    const {  spu_id,  show_real_inventory,   } = params

    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling getAllSkus1.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/{spu_id}/skus`.includes(prefix) ? `/business/v1/product/spus/{spu_id}/skus` : prefix + `/business/v1/product/spus/{spu_id}/skus`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (show_real_inventory !== undefined) {
        localVarQueryParameter.show_real_inventory = show_real_inventory;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve the sku inventory list of a specific spu by spu_id
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {'CURRENT' | 'LOCKED'} sku_inventory_type sku_inventory_type
    *@param {number} [sku_id] sku_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getSkuInventory(params = {} as IgetSkuInventoryParams, options: any = {}): FetchArgs {
    const {  spu_id,  sku_id, sku_inventory_type,   } = params

    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling getSkuInventory.');
    }

    // verify required query 'sku_inventory_type' is not null or undefined
    if (sku_inventory_type === null || sku_inventory_type === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('sku_inventory_type', 'Required parameter sku_inventory_type was null or undefined when calling getSkuInventory.');
    }

    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/{spu_id}/skus/inventory`.includes(prefix) ? `/business/v1/product/spus/{spu_id}/skus/inventory` : prefix + `/business/v1/product/spus/{spu_id}/skus/inventory`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (sku_id !== undefined) {
        localVarQueryParameter.sku_id = sku_id;
    }

    if (sku_inventory_type !== undefined) {
        localVarQueryParameter.sku_inventory_type = sku_inventory_type;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary batch update sku inventory
    *@param {string} cookie 
    *@param {UpdateInventoryListRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateBatchSkuInventory(params = {} as IupdateBatchSkuInventoryParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updateBatchSkuInventory.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/skus/inventory/batch`.includes(prefix) ? `/business/v1/product/spus/skus/inventory/batch` : prefix + `/business/v1/product/spus/skus/inventory/batch`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PUT', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateInventoryListRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update sku inventory by spu_id and sku_id
    *@param {string} sku_id 
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {SkuInventoryRequest} sku_inventory_request skuInventoryRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateSkuInventory(params = {} as IupdateSkuInventoryParams, options: any = {}): FetchArgs {
    const { sku_inventory_request,  sku_id, spu_id,    } = params
    // verify required body 'sku_inventory_request' is not null or undefined
    if (sku_inventory_request === null || sku_inventory_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('sku_inventory_request', 'Required parameter sku_inventory_request was null or undefined when calling updateSkuInventory.');
    }

    // verify required path 'sku_id' is not null or undefined
    if (sku_id === null || sku_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('sku_id', 'Required parameter sku_id was null or undefined when calling updateSkuInventory.');
    }
    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling updateSkuInventory.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/{spu_id}/skus/{sku_id}/inventory`.includes(prefix) ? `/business/v1/product/spus/{spu_id}/skus/{sku_id}/inventory` : prefix + `/business/v1/product/spus/{spu_id}/skus/{sku_id}/inventory`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"sku_id"}}`, encodeURIComponent(String(sku_id)))
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"SkuInventoryRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(sku_inventory_request || {}) : (sku_inventory_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update the status of a specific sku by spu_id and related sku_id
    *@param {string} sku_id 
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {SkuStatusRequest} sku_status_request skuStatusRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateSkuStatus(params = {} as IupdateSkuStatusParams, options: any = {}): FetchArgs {
    const { sku_status_request,  sku_id, spu_id,    } = params
    // verify required body 'sku_status_request' is not null or undefined
    if (sku_status_request === null || sku_status_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('sku_status_request', 'Required parameter sku_status_request was null or undefined when calling updateSkuStatus.');
    }

    // verify required path 'sku_id' is not null or undefined
    if (sku_id === null || sku_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('sku_id', 'Required parameter sku_id was null or undefined when calling updateSkuStatus.');
    }
    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling updateSkuStatus.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/{spu_id}/skus/{sku_id}/status`.includes(prefix) ? `/business/v1/product/spus/{spu_id}/skus/{sku_id}/status` : prefix + `/business/v1/product/spus/{spu_id}/skus/{sku_id}/status`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"sku_id"}}`, encodeURIComponent(String(sku_id)))
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"SkuStatusRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(sku_status_request || {}) : (sku_status_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update the sku list for the spu by spu_id
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {UpdateSkuListRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateSkulist(params = {} as IupdateSkulistParams, options: any = {}): FetchArgs {
    const { request,  spu_id,    } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updateSkulist.');
    }

    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling updateSkulist.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/{spu_id}/skulist`.includes(prefix) ? `/business/v1/product/spus/{spu_id}/skulist` : prefix + `/business/v1/product/spus/{spu_id}/skulist`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateSkuListRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update the sku list for a specific spu by spu_id
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {SkuListRequest} sku_list_request skuListRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateSkus1(params = {} as IupdateSkus1Params, options: any = {}): FetchArgs {
    const { sku_list_request,  spu_id,    } = params
    // verify required body 'sku_list_request' is not null or undefined
    if (sku_list_request === null || sku_list_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('sku_list_request', 'Required parameter sku_list_request was null or undefined when calling updateSkus1.');
    }

    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling updateSkus1.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/{spu_id}/skus`.includes(prefix) ? `/business/v1/product/spus/{spu_id}/skus` : prefix + `/business/v1/product/spus/{spu_id}/skus`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"SkuListRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(sku_list_request || {}) : (sku_list_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IgetAllSkus2Params {
  
  show_real_inventory?: boolean, 
  external_spu_id: string, 
  
}
export interface IgetSkuInventoryByExternalParams {
  
  external_sku_id?: string, sku_inventory_type: 'CURRENT' | 'LOCKED', 
  spu_id: string, external_spu_id: string, 
  
}
export interface IupdateBatchSkuInventory1Params {
  request: UpdateInventoryByExternalSkuIdListRequest, 
  
  
  
}
export interface IupdateSkuInventory1Params {
  external_sku_inventory_request: ExternalSkuInventoryRequest, 
  
  external_sku_id: string, 
  
}
export interface IupdateSkus2Params {
  sku_list_request: SkuListRequest, 
  
  external_spu_id: string, 
  
}

/**
 *SkuExternalControllerApi - fetch parameter creator
 *@export
 */
export const SkuExternalControllerApiParamCreator = {
  /**
    *
    *@summary retrieve the sku list with full info of a specific spu by external_spu_id
    *@param {string} cookie 
    *@param {string} external_spu_id external_spu_id
    *@param {boolean} [show_real_inventory] show_real_inventory
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getAllSkus2(params = {} as IgetAllSkus2Params, options: any = {}): FetchArgs {
    const {  external_spu_id,  show_real_inventory,   } = params

    // verify required path 'external_spu_id' is not null or undefined
    if (external_spu_id === null || external_spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('external_spu_id', 'Required parameter external_spu_id was null or undefined when calling getAllSkus2.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/external/{external_spu_id}/skus`.includes(prefix) ? `/business/v1/product/spus/external/{external_spu_id}/skus` : prefix + `/business/v1/product/spus/external/{external_spu_id}/skus`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"external_spu_id"}}`, encodeURIComponent(String(external_spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (show_real_inventory !== undefined) {
        localVarQueryParameter.show_real_inventory = show_real_inventory;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve the sku inventory list of a specific spu by external_spu_id
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {string} external_spu_id external_spu_id
    *@param {'CURRENT' | 'LOCKED'} sku_inventory_type sku_inventory_type
    *@param {string} [external_sku_id] external_sku_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getSkuInventoryByExternal(params = {} as IgetSkuInventoryByExternalParams, options: any = {}): FetchArgs {
    const {  spu_id, external_spu_id,  external_sku_id, sku_inventory_type,   } = params

    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling getSkuInventoryByExternal.');
    }
    // verify required path 'external_spu_id' is not null or undefined
    if (external_spu_id === null || external_spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('external_spu_id', 'Required parameter external_spu_id was null or undefined when calling getSkuInventoryByExternal.');
    }

    // verify required query 'sku_inventory_type' is not null or undefined
    if (sku_inventory_type === null || sku_inventory_type === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('sku_inventory_type', 'Required parameter sku_inventory_type was null or undefined when calling getSkuInventoryByExternal.');
    }

    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/external/{external_spu_id}/skus/inventory`.includes(prefix) ? `/business/v1/product/spus/external/{external_spu_id}/skus/inventory` : prefix + `/business/v1/product/spus/external/{external_spu_id}/skus/inventory`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)))
        .replace(`{${"external_spu_id"}}`, encodeURIComponent(String(external_spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (external_sku_id !== undefined) {
        localVarQueryParameter.external_sku_id = external_sku_id;
    }

    if (sku_inventory_type !== undefined) {
        localVarQueryParameter.sku_inventory_type = sku_inventory_type;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary batch update sku inventory by external_spu_id
    *@param {string} cookie 
    *@param {UpdateInventoryByExternalSkuIdListRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateBatchSkuInventory1(params = {} as IupdateBatchSkuInventory1Params, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updateBatchSkuInventory1.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/external/skus/inventory/batch`.includes(prefix) ? `/business/v1/product/spus/external/skus/inventory/batch` : prefix + `/business/v1/product/spus/external/skus/inventory/batch`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PUT', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateInventoryByExternalSkuIdListRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update sku inventory by external_spu_id
    *@param {string} cookie 
    *@param {ExternalSkuInventoryRequest} external_sku_inventory_request externalSkuInventoryRequest
    *@param {string} external_sku_id external_sku_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateSkuInventory1(params = {} as IupdateSkuInventory1Params, options: any = {}): FetchArgs {
    const { external_sku_inventory_request,  external_sku_id,    } = params
    // verify required body 'external_sku_inventory_request' is not null or undefined
    if (external_sku_inventory_request === null || external_sku_inventory_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('external_sku_inventory_request', 'Required parameter external_sku_inventory_request was null or undefined when calling updateSkuInventory1.');
    }

    // verify required path 'external_sku_id' is not null or undefined
    if (external_sku_id === null || external_sku_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('external_sku_id', 'Required parameter external_sku_id was null or undefined when calling updateSkuInventory1.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/external/skus/{external_sku_id}/inventory`.includes(prefix) ? `/business/v1/product/spus/external/skus/{external_sku_id}/inventory` : prefix + `/business/v1/product/spus/external/skus/{external_sku_id}/inventory`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"external_sku_id"}}`, encodeURIComponent(String(external_sku_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"ExternalSkuInventoryRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(external_sku_inventory_request || {}) : (external_sku_inventory_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update the sku list for a specific spu by external_spu_id
    *@param {string} cookie 
    *@param {string} external_spu_id external_spu_id
    *@param {SkuListRequest} sku_list_request skuListRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateSkus2(params = {} as IupdateSkus2Params, options: any = {}): FetchArgs {
    const { sku_list_request,  external_spu_id,    } = params
    // verify required body 'sku_list_request' is not null or undefined
    if (sku_list_request === null || sku_list_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('sku_list_request', 'Required parameter sku_list_request was null or undefined when calling updateSkus2.');
    }

    // verify required path 'external_spu_id' is not null or undefined
    if (external_spu_id === null || external_spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('external_spu_id', 'Required parameter external_spu_id was null or undefined when calling updateSkus2.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/external/{external_spu_id}/skus`.includes(prefix) ? `/business/v1/product/spus/external/{external_spu_id}/skus` : prefix + `/business/v1/product/spus/external/{external_spu_id}/skus`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"external_spu_id"}}`, encodeURIComponent(String(external_spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"SkuListRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(sku_list_request || {}) : (sku_list_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IcreateSpuParams {
  create_spu_request: CreateSpuRequest, 
  
  
  
}
export interface IdeleteSpuParams {
  
  
  spu_id: string, 
  
}
export interface IdeleteSpuCategoryParams {
  
  
  category_id: string, spu_id: string, 
  
}
export interface IlistPurchaseLimitParams {
  
  
  spu_id: string, 
  
}
export interface IoptionalUpdateSpuParams {
  request: OptionalUpdateSpuRequest, 
  
  spu_id: string, 
  
}
export interface IspuCategoryListParams {
  
  spu_status?: 'UP' | 'DOWN', keyword?: string, num?: number, page?: number, presale?: string, sku_type?: 'NONE' | 'SINGLE' | 'MULTIPLE', spu_name?: string, 
  category_id: string, 
  
}
export interface IspuDetailParams {
  
  
  spu_id: string, 
  
}
export interface IspuListParams {
  
  inventory_max?: number, inventory_min?: number, keyword?: string, num?: number, page?: number, presale?: boolean, searchable?: boolean, sku_type?: 'NONE' | 'SINGLE' | 'MULTIPLE', spu_status?: 'ENABLED' | 'DISABLED', 
  
  
}
export interface IupdateCategoryIdParams {
  update_spu_category_request: UpdateSpuCategoryRequest, 
  
  spu_id: string, 
  
}
export interface IupdateCategorySpuSortParams {
  request: UpdateSpuSortRequest, 
  
  category_id: string, 
  
}
export interface IupdatePresaleParams {
  request: UpdatePresaleRequest, 
  
  spu_id: string, 
  
}
export interface IupdatePurchaseLimitParams {
  request: UpdatePurchaseLimitRequest, 
  
  spu_id: string, 
  
}
export interface IupdateSpuParams {
  request: UpdateSpuRequest, 
  
  spu_id: string, 
  
}
export interface IupdateSpuAttributeParams {
  update_spu_attribute_request: UpdateSpuAttributeRequest, 
  
  spu_id: string, 
  
}
export interface IupdateSpuStatus1Params {
  request: UpdateSpuStatusRequest, 
  
  spu_id: string, 
  
}
export interface IupdateSpuVariationAttributeParams {
  update_spu_va_request: UpdateSpuVARequest, 
  
  spu_id: string, 
  
}

/**
 *SpuControllerApi - fetch parameter creator
 *@export
 */
export const SpuControllerApiParamCreator = {
  /**
    *
    *@summary create a new spu
    *@param {string} cookie 
    *@param {CreateSpuRequest} create_spu_request createSpuRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  createSpu(params = {} as IcreateSpuParams, options: any = {}): FetchArgs {
    const { create_spu_request,     } = params
    // verify required body 'create_spu_request' is not null or undefined
    if (create_spu_request === null || create_spu_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('create_spu_request', 'Required parameter create_spu_request was null or undefined when calling createSpu.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus`.includes(prefix) ? `/business/v1/product/spus` : prefix + `/business/v1/product/spus`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"CreateSpuRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(create_spu_request || {}) : (create_spu_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary delete a specific spu by spu_id
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  deleteSpu(params = {} as IdeleteSpuParams, options: any = {}): FetchArgs {
    const {  spu_id,    } = params

    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling deleteSpu.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/{spu_id}`.includes(prefix) ? `/business/v1/product/spus/{spu_id}` : prefix + `/business/v1/product/spus/{spu_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'DELETE', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary delete the relationship between a specific category and a specific spu
    *@param {string} category_id 
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  deleteSpuCategory(params = {} as IdeleteSpuCategoryParams, options: any = {}): FetchArgs {
    const {  category_id, spu_id,    } = params

    // verify required path 'category_id' is not null or undefined
    if (category_id === null || category_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('category_id', 'Required parameter category_id was null or undefined when calling deleteSpuCategory.');
    }
    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling deleteSpuCategory.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/{spu_id}/categories/{category_id}`.includes(prefix) ? `/business/v1/product/spus/{spu_id}/categories/{category_id}` : prefix + `/business/v1/product/spus/{spu_id}/categories/{category_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"category_id"}}`, encodeURIComponent(String(category_id)))
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'DELETE', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary list purchase limit by spu_id
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  listPurchaseLimit(params = {} as IlistPurchaseLimitParams, options: any = {}): FetchArgs {
    const {  spu_id,    } = params

    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling listPurchaseLimit.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/{spu_id}/purchase_limit`.includes(prefix) ? `/business/v1/product/spus/{spu_id}/purchase_limit` : prefix + `/business/v1/product/spus/{spu_id}/purchase_limit`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update optional detail of a specific spu by spu_id
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {OptionalUpdateSpuRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  optionalUpdateSpu(params = {} as IoptionalUpdateSpuParams, options: any = {}): FetchArgs {
    const { request,  spu_id,    } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling optionalUpdateSpu.');
    }

    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling optionalUpdateSpu.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/{spu_id}`.includes(prefix) ? `/business/v1/product/spus/{spu_id}` : prefix + `/business/v1/product/spus/{spu_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"OptionalUpdateSpuRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve the basic info list of spu belonged to a specific category
    *@param {string} category_id 
    *@param {string} cookie 
    *@param {'UP' | 'DOWN'} [spu_status] 
    *@param {string} [keyword] keyword
    *@param {number} [num] num
    *@param {number} [page] page
    *@param {string} [presale] presale
    *@param {'NONE' | 'SINGLE' | 'MULTIPLE'} [sku_type] sku_type
    *@param {string} [spu_name] spu_name
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  spuCategoryList(params = {} as IspuCategoryListParams, options: any = {}): FetchArgs {
    const {  category_id,  spu_status, keyword, num, page, presale, sku_type, spu_name,   } = params

    // verify required path 'category_id' is not null or undefined
    if (category_id === null || category_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('category_id', 'Required parameter category_id was null or undefined when calling spuCategoryList.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/categories/{category_id}`.includes(prefix) ? `/business/v1/product/spus/categories/{category_id}` : prefix + `/business/v1/product/spus/categories/{category_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"category_id"}}`, encodeURIComponent(String(category_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (spu_status !== undefined) {
        localVarQueryParameter.spu_status = spu_status;
    }

    if (keyword !== undefined) {
        localVarQueryParameter.keyword = keyword;
    }

    if (num !== undefined) {
        localVarQueryParameter.num = num;
    }

    if (page !== undefined) {
        localVarQueryParameter.page = page;
    }

    if (presale !== undefined) {
        localVarQueryParameter.presale = presale;
    }

    if (sku_type !== undefined) {
        localVarQueryParameter.sku_type = sku_type;
    }

    if (spu_name !== undefined) {
        localVarQueryParameter.spu_name = spu_name;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve the full detail of a specific spu by spu_id
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  spuDetail(params = {} as IspuDetailParams, options: any = {}): FetchArgs {
    const {  spu_id,    } = params

    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling spuDetail.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/{spu_id}`.includes(prefix) ? `/business/v1/product/spus/{spu_id}` : prefix + `/business/v1/product/spus/{spu_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve the basic info list of spu for all category
    *@param {string} cookie 
    *@param {number} [inventory_max] inventory_max
    *@param {number} [inventory_min] inventory_min
    *@param {string} [keyword] keyword
    *@param {number} [num] num
    *@param {number} [page] page
    *@param {boolean} [presale] presale
    *@param {boolean} [searchable] searchable
    *@param {'NONE' | 'SINGLE' | 'MULTIPLE'} [sku_type] sku_type
    *@param {'ENABLED' | 'DISABLED'} [spu_status] spu_status
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  spuList(params = {} as IspuListParams, options: any = {}): FetchArgs {
    const {   inventory_max, inventory_min, keyword, num, page, presale, searchable, sku_type, spu_status,   } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus`.includes(prefix) ? `/business/v1/product/spus` : prefix + `/business/v1/product/spus`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (inventory_max !== undefined) {
        localVarQueryParameter.inventory_max = inventory_max;
    }

    if (inventory_min !== undefined) {
        localVarQueryParameter.inventory_min = inventory_min;
    }

    if (keyword !== undefined) {
        localVarQueryParameter.keyword = keyword;
    }

    if (num !== undefined) {
        localVarQueryParameter.num = num;
    }

    if (page !== undefined) {
        localVarQueryParameter.page = page;
    }

    if (presale !== undefined) {
        localVarQueryParameter.presale = presale;
    }

    if (searchable !== undefined) {
        localVarQueryParameter.searchable = searchable;
    }

    if (sku_type !== undefined) {
        localVarQueryParameter.sku_type = sku_type;
    }

    if (spu_status !== undefined) {
        localVarQueryParameter.spu_status = spu_status;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update a specific spu category by spu_id
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {UpdateSpuCategoryRequest} update_spu_category_request updateSpuCategoryRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateCategoryId(params = {} as IupdateCategoryIdParams, options: any = {}): FetchArgs {
    const { update_spu_category_request,  spu_id,    } = params
    // verify required body 'update_spu_category_request' is not null or undefined
    if (update_spu_category_request === null || update_spu_category_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('update_spu_category_request', 'Required parameter update_spu_category_request was null or undefined when calling updateCategoryId.');
    }

    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling updateCategoryId.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/{spu_id}/categories`.includes(prefix) ? `/business/v1/product/spus/{spu_id}/categories` : prefix + `/business/v1/product/spus/{spu_id}/categories`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateSpuCategoryRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(update_spu_category_request || {}) : (update_spu_category_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update spu sort of category
    *@param {string} category_id 
    *@param {string} cookie 
    *@param {UpdateSpuSortRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateCategorySpuSort(params = {} as IupdateCategorySpuSortParams, options: any = {}): FetchArgs {
    const { request,  category_id,    } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updateCategorySpuSort.');
    }

    // verify required path 'category_id' is not null or undefined
    if (category_id === null || category_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('category_id', 'Required parameter category_id was null or undefined when calling updateCategorySpuSort.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/categories/{category_id}/sorted_spu`.includes(prefix) ? `/business/v1/product/spus/categories/{category_id}/sorted_spu` : prefix + `/business/v1/product/spus/categories/{category_id}/sorted_spu`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"category_id"}}`, encodeURIComponent(String(category_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateSpuSortRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update a specific spu presale by spu_id
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {UpdatePresaleRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updatePresale(params = {} as IupdatePresaleParams, options: any = {}): FetchArgs {
    const { request,  spu_id,    } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updatePresale.');
    }

    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling updatePresale.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/{spu_id}/presale`.includes(prefix) ? `/business/v1/product/spus/{spu_id}/presale` : prefix + `/business/v1/product/spus/{spu_id}/presale`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdatePresaleRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update a purchase limit by spu_id
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {UpdatePurchaseLimitRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updatePurchaseLimit(params = {} as IupdatePurchaseLimitParams, options: any = {}): FetchArgs {
    const { request,  spu_id,    } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updatePurchaseLimit.');
    }

    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling updatePurchaseLimit.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/{spu_id}/purchase_limit`.includes(prefix) ? `/business/v1/product/spus/{spu_id}/purchase_limit` : prefix + `/business/v1/product/spus/{spu_id}/purchase_limit`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdatePurchaseLimitRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update a specific spu by spu_id
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {UpdateSpuRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateSpu(params = {} as IupdateSpuParams, options: any = {}): FetchArgs {
    const { request,  spu_id,    } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updateSpu.');
    }

    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling updateSpu.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/{spu_id}`.includes(prefix) ? `/business/v1/product/spus/{spu_id}` : prefix + `/business/v1/product/spus/{spu_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PUT', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateSpuRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update a specific spu attribute by spu_id
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {UpdateSpuAttributeRequest} update_spu_attribute_request updateSpuAttributeRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateSpuAttribute(params = {} as IupdateSpuAttributeParams, options: any = {}): FetchArgs {
    const { update_spu_attribute_request,  spu_id,    } = params
    // verify required body 'update_spu_attribute_request' is not null or undefined
    if (update_spu_attribute_request === null || update_spu_attribute_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('update_spu_attribute_request', 'Required parameter update_spu_attribute_request was null or undefined when calling updateSpuAttribute.');
    }

    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling updateSpuAttribute.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/{spu_id}/attributes`.includes(prefix) ? `/business/v1/product/spus/{spu_id}/attributes` : prefix + `/business/v1/product/spus/{spu_id}/attributes`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateSpuAttributeRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(update_spu_attribute_request || {}) : (update_spu_attribute_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update the shelves status of a specific spu by spu_id
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {UpdateSpuStatusRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateSpuStatus1(params = {} as IupdateSpuStatus1Params, options: any = {}): FetchArgs {
    const { request,  spu_id,    } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updateSpuStatus1.');
    }

    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling updateSpuStatus1.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/{spu_id}/spu_status`.includes(prefix) ? `/business/v1/product/spus/{spu_id}/spu_status` : prefix + `/business/v1/product/spus/{spu_id}/spu_status`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateSpuStatusRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update a specific spu variation attribute by spu_id
    *@param {string} spu_id 
    *@param {string} cookie 
    *@param {UpdateSpuVARequest} update_spu_va_request updateSpuVARequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateSpuVariationAttribute(params = {} as IupdateSpuVariationAttributeParams, options: any = {}): FetchArgs {
    const { update_spu_va_request,  spu_id,    } = params
    // verify required body 'update_spu_va_request' is not null or undefined
    if (update_spu_va_request === null || update_spu_va_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('update_spu_va_request', 'Required parameter update_spu_va_request was null or undefined when calling updateSpuVariationAttribute.');
    }

    // verify required path 'spu_id' is not null or undefined
    if (spu_id === null || spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('spu_id', 'Required parameter spu_id was null or undefined when calling updateSpuVariationAttribute.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/{spu_id}/variation_attributes`.includes(prefix) ? `/business/v1/product/spus/{spu_id}/variation_attributes` : prefix + `/business/v1/product/spus/{spu_id}/variation_attributes`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"spu_id"}}`, encodeURIComponent(String(spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateSpuVARequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(update_spu_va_request || {}) : (update_spu_va_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IdeleteExternalSpu1Params {
  
  
  external_spu_id: string, 
  
}
export interface IexternalSpuDetail1Params {
  
  
  external_spu_id: string, 
  
}
export interface IupdateExternalSpu1Params {
  request: UpdateSpuRequest, 
  
  external_spu_id: string, 
  
}
export interface IupdateSpuAttribute1Params {
  update_spu_attribute_request: UpdateSpuAttributeRequest, 
  
  external_spu_id: string, 
  
}
export interface IupdateSpuStatus2Params {
  request: UpdateSpuStatusRequest, 
  
  external_spu_id: string, 
  
}
export interface IupdateSpuVariationAttribute1Params {
  update_spu_va_request: UpdateSpuVARequest, 
  
  external_spu_id: string, 
  
}

/**
 *SpuExternalControllerApi - fetch parameter creator
 *@export
 */
export const SpuExternalControllerApiParamCreator = {
  /**
    *
    *@summary delete a specific spu by external_spu_id
    *@param {string} cookie 
    *@param {string} external_spu_id external_spu_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  deleteExternalSpu1(params = {} as IdeleteExternalSpu1Params, options: any = {}): FetchArgs {
    const {  external_spu_id,    } = params

    // verify required path 'external_spu_id' is not null or undefined
    if (external_spu_id === null || external_spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('external_spu_id', 'Required parameter external_spu_id was null or undefined when calling deleteExternalSpu1.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/external/{external_spu_id}`.includes(prefix) ? `/business/v1/product/spus/external/{external_spu_id}` : prefix + `/business/v1/product/spus/external/{external_spu_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"external_spu_id"}}`, encodeURIComponent(String(external_spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'DELETE', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve the full detail of a specific spu by external_spu_id
    *@param {string} cookie 
    *@param {string} external_spu_id external_spu_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  externalSpuDetail1(params = {} as IexternalSpuDetail1Params, options: any = {}): FetchArgs {
    const {  external_spu_id,    } = params

    // verify required path 'external_spu_id' is not null or undefined
    if (external_spu_id === null || external_spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('external_spu_id', 'Required parameter external_spu_id was null or undefined when calling externalSpuDetail1.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/external/{external_spu_id}`.includes(prefix) ? `/business/v1/product/spus/external/{external_spu_id}` : prefix + `/business/v1/product/spus/external/{external_spu_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"external_spu_id"}}`, encodeURIComponent(String(external_spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update a specific spu by external_spu_id
    *@param {string} cookie 
    *@param {string} external_spu_id external_spu_id
    *@param {UpdateSpuRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateExternalSpu1(params = {} as IupdateExternalSpu1Params, options: any = {}): FetchArgs {
    const { request,  external_spu_id,    } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updateExternalSpu1.');
    }

    // verify required path 'external_spu_id' is not null or undefined
    if (external_spu_id === null || external_spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('external_spu_id', 'Required parameter external_spu_id was null or undefined when calling updateExternalSpu1.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/external/{external_spu_id}`.includes(prefix) ? `/business/v1/product/spus/external/{external_spu_id}` : prefix + `/business/v1/product/spus/external/{external_spu_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"external_spu_id"}}`, encodeURIComponent(String(external_spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PUT', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateSpuRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update a specific spu attribute by external_spu_id
    *@param {string} cookie 
    *@param {string} external_spu_id external_spu_id
    *@param {UpdateSpuAttributeRequest} update_spu_attribute_request updateSpuAttributeRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateSpuAttribute1(params = {} as IupdateSpuAttribute1Params, options: any = {}): FetchArgs {
    const { update_spu_attribute_request,  external_spu_id,    } = params
    // verify required body 'update_spu_attribute_request' is not null or undefined
    if (update_spu_attribute_request === null || update_spu_attribute_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('update_spu_attribute_request', 'Required parameter update_spu_attribute_request was null or undefined when calling updateSpuAttribute1.');
    }

    // verify required path 'external_spu_id' is not null or undefined
    if (external_spu_id === null || external_spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('external_spu_id', 'Required parameter external_spu_id was null or undefined when calling updateSpuAttribute1.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/external/{external_spu_id}/attribute`.includes(prefix) ? `/business/v1/product/spus/external/{external_spu_id}/attribute` : prefix + `/business/v1/product/spus/external/{external_spu_id}/attribute`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"external_spu_id"}}`, encodeURIComponent(String(external_spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateSpuAttributeRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(update_spu_attribute_request || {}) : (update_spu_attribute_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update the shelves status of a specific spu by external_spu_id
    *@param {string} cookie 
    *@param {string} external_spu_id external_spu_id
    *@param {UpdateSpuStatusRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateSpuStatus2(params = {} as IupdateSpuStatus2Params, options: any = {}): FetchArgs {
    const { request,  external_spu_id,    } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updateSpuStatus2.');
    }

    // verify required path 'external_spu_id' is not null or undefined
    if (external_spu_id === null || external_spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('external_spu_id', 'Required parameter external_spu_id was null or undefined when calling updateSpuStatus2.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/external/{external_spu_id}/spu_status`.includes(prefix) ? `/business/v1/product/spus/external/{external_spu_id}/spu_status` : prefix + `/business/v1/product/spus/external/{external_spu_id}/spu_status`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"external_spu_id"}}`, encodeURIComponent(String(external_spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateSpuStatusRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update a specific spu variation attribute by external_spu_id
    *@param {string} cookie 
    *@param {string} external_spu_id external_spu_id
    *@param {UpdateSpuVARequest} update_spu_va_request updateSpuVARequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateSpuVariationAttribute1(params = {} as IupdateSpuVariationAttribute1Params, options: any = {}): FetchArgs {
    const { update_spu_va_request,  external_spu_id,    } = params
    // verify required body 'update_spu_va_request' is not null or undefined
    if (update_spu_va_request === null || update_spu_va_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('update_spu_va_request', 'Required parameter update_spu_va_request was null or undefined when calling updateSpuVariationAttribute1.');
    }

    // verify required path 'external_spu_id' is not null or undefined
    if (external_spu_id === null || external_spu_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('external_spu_id', 'Required parameter external_spu_id was null or undefined when calling updateSpuVariationAttribute1.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/spus/external/{external_spu_id}/variation_attribute`.includes(prefix) ? `/business/v1/product/spus/external/{external_spu_id}/variation_attribute` : prefix + `/business/v1/product/spus/external/{external_spu_id}/variation_attribute`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"external_spu_id"}}`, encodeURIComponent(String(external_spu_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateSpuVARequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(update_spu_va_request || {}) : (update_spu_va_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IcreateVariationAttributeParams {
  create_variation_attribute_request: CreateVariationAttributeRequest, 
  
  
  
}
export interface IdeleteVariationAttributeParams {
  
  
  variation_attribute_id: string, 
  
}
export interface IupdateVariationAttributeParams {
  update_variation_attribute_request: UpdateVariationAttributeRequest, 
  
  variation_attribute_id: string, 
  
}
export interface IvariationAttributeAllParams {
  
  keyword?: string, 
  
  
}
export interface IvariationAttributeDetailParams {
  
  
  variation_attribute_id: string, 
  
}

/**
 *VariationAttributeControllerApi - fetch parameter creator
 *@export
 */
export const VariationAttributeControllerApiParamCreator = {
  /**
    *
    *@summary create a new variation attribute
    *@param {string} cookie 
    *@param {CreateVariationAttributeRequest} create_variation_attribute_request createVariationAttributeRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  createVariationAttribute(params = {} as IcreateVariationAttributeParams, options: any = {}): FetchArgs {
    const { create_variation_attribute_request,     } = params
    // verify required body 'create_variation_attribute_request' is not null or undefined
    if (create_variation_attribute_request === null || create_variation_attribute_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('create_variation_attribute_request', 'Required parameter create_variation_attribute_request was null or undefined when calling createVariationAttribute.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/variation_attributes`.includes(prefix) ? `/business/v1/product/variation_attributes` : prefix + `/business/v1/product/variation_attributes`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"CreateVariationAttributeRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(create_variation_attribute_request || {}) : (create_variation_attribute_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary delete a specific variation attribute by variation_attribute_id
    *@param {string} variation_attribute_id 
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  deleteVariationAttribute(params = {} as IdeleteVariationAttributeParams, options: any = {}): FetchArgs {
    const {  variation_attribute_id,    } = params

    // verify required path 'variation_attribute_id' is not null or undefined
    if (variation_attribute_id === null || variation_attribute_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('variation_attribute_id', 'Required parameter variation_attribute_id was null or undefined when calling deleteVariationAttribute.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/variation_attributes/{variation_attribute_id}`.includes(prefix) ? `/business/v1/product/variation_attributes/{variation_attribute_id}` : prefix + `/business/v1/product/variation_attributes/{variation_attribute_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"variation_attribute_id"}}`, encodeURIComponent(String(variation_attribute_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'DELETE', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update a specific variation attribute by variation_attribute_id
    *@param {string} variation_attribute_id 
    *@param {string} cookie 
    *@param {UpdateVariationAttributeRequest} update_variation_attribute_request updateVariationAttributeRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateVariationAttribute(params = {} as IupdateVariationAttributeParams, options: any = {}): FetchArgs {
    const { update_variation_attribute_request,  variation_attribute_id,    } = params
    // verify required body 'update_variation_attribute_request' is not null or undefined
    if (update_variation_attribute_request === null || update_variation_attribute_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('update_variation_attribute_request', 'Required parameter update_variation_attribute_request was null or undefined when calling updateVariationAttribute.');
    }

    // verify required path 'variation_attribute_id' is not null or undefined
    if (variation_attribute_id === null || variation_attribute_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('variation_attribute_id', 'Required parameter variation_attribute_id was null or undefined when calling updateVariationAttribute.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/variation_attributes/{variation_attribute_id}`.includes(prefix) ? `/business/v1/product/variation_attributes/{variation_attribute_id}` : prefix + `/business/v1/product/variation_attributes/{variation_attribute_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"variation_attribute_id"}}`, encodeURIComponent(String(variation_attribute_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PUT', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateVariationAttributeRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(update_variation_attribute_request || {}) : (update_variation_attribute_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve a list of all variation attributes by keyword
    *@param {string} cookie 
    *@param {string} [keyword] keyword
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  variationAttributeAll(params = {} as IvariationAttributeAllParams, options: any = {}): FetchArgs {
    const {   keyword,   } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/variation_attributes`.includes(prefix) ? `/business/v1/product/variation_attributes` : prefix + `/business/v1/product/variation_attributes`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (keyword !== undefined) {
        localVarQueryParameter.keyword = keyword;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve a specific variation attribute value by variation_attribute_id
    *@param {string} variation_attribute_id 
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  variationAttributeDetail(params = {} as IvariationAttributeDetailParams, options: any = {}): FetchArgs {
    const {  variation_attribute_id,    } = params

    // verify required path 'variation_attribute_id' is not null or undefined
    if (variation_attribute_id === null || variation_attribute_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('variation_attribute_id', 'Required parameter variation_attribute_id was null or undefined when calling variationAttributeDetail.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/product".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/product/variation_attributes/{variation_attribute_id}`.includes(prefix) ? `/business/v1/product/variation_attributes/{variation_attribute_id}` : prefix + `/business/v1/product/variation_attributes/{variation_attribute_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"variation_attribute_id"}}`, encodeURIComponent(String(variation_attribute_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};


